/* eslint-disable complexity */
/* eslint-disable sonarjs/cognitive-complexity */
/* eslint-disable max-lines */
// 9fbef606107a605d69c0edbcd8029e5d
import React from 'react';
import dynamic from 'next/dynamic';
import Head from 'next/head';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { initialize } from 'redux-form';
import ExecutionEnvironment from 'exenv';
import { breakpoints } from '@tcp/core/styles/themes/TCP/mediaQuery';
import withDynamicSaga from '@tcp/core/src/components/common/hoc/withDynamicSaga';
import withDynamicReducer from '@tcp/core/src/components/common/hoc/withDynamicReducer';
import { withRouter } from 'next/router'; // eslint-disable-line
import hoistNonReactStatic from 'hoist-non-react-statics';
import withRefWrapper from '@tcp/core/src/components/common/hoc/withRefWrapper';
import { getLocalStorage } from '@tcp/core/src/utils/localStorageManagement';
import AddedToBagReducer from '@tcp/core/src/components/features/CnC/AddedToBag/container/AddedToBag.reducer';
import AddedToBagSaga from '@tcp/core/src/components/features/CnC/AddedToBag/container/AddedToBag.saga';
import { toggleApplyNowModal } from '@tcp/core/src/components/common/molecules/ApplyNowPLCCModal/container/ApplyNowModal.actions';
import withHotfix from '@tcp/core/src/components/common/hoc/withHotfix';
import { getQVProductData } from '@tcp/core/src/components/common/organisms/QuickViewModal/container/QuickViewModal.selectors';
import moduleGConfig from '@tcp/core/src/components/common/molecules/ModuleG/moduleG.config';
import moduleJConfig from '@tcp/core/src/components/common/molecules/ModuleJ/moduleJ.config';
import { imageData } from '@tcp/core/src/components/features/browse/OutfitDetails/config';
import { OpenBirthdayRecommandationDrawer } from '@tcp/core/src/components/features/account/BirthdayProductListing/container/BirthdayProductListing.actions';
import { getDrawerSet } from '@tcp/core/src/components/features/account/BirthdayProductListing/container/BirthdayProductListing.selectors';
import SEOTags from '@tcp/web/src/components/common/atoms/SEOTags/SEOTags';
import { NextSeo } from 'next-seo';
import {
  getIfBotDevice,
  getObjectValue,
  isClient,
  parseBoolean,
  getRecommendation,
  scrollToBreadCrumb,
  isMobileWeb,
  isServer,
  getAPIConfig,
  setSessionStorage,
  getSessionStorage,
  getViewportInfo,
  getBrandInCaps,
  prefetchImportantChunks,
  getAspectRatio,
} from '@tcp/core/src/utils';
import { getBrandNameFromHref } from '@tcp/core/src/utils/utils';
import { deriveSEOTags } from '@tcp/core/src/config/SEOTags.config';
import { arrayOf, bool, func, shape, string } from 'prop-types';
import {
  getDefaultStore,
  getUserLoggedInState,
  isRememberedUser,
  isPlccUser,
  getUserId,
} from '@tcp/core/src/components/features/account/User/container/User.selectors';
import {
  getAPIConfigForAdobe,
  getSessionDataForAdobe,
} from '@tcp/core/src/adobeAnalytics/adobe.selectors';
import {
  getIsWriteReviewModalOpen,
  getIsAddPhotoModalOpen,
  getIsAddVideoModalOpen,
  getIsSubmissionFeedbackModalOpen,
} from '@tcp/core/src/components/features/browse/WriteReviewDetail/container/WriteReview.selectors';
import { getAddBgdToTransparentImgEnabled } from '@tcp/core/src/reduxStore/selectors/labels.selectors';
import {
  getProducts,
  getSimilarItemToConsiderFromRecommendation,
} from '@tcp/core/src/components/common/molecules/Recommendations/container/Recommendations.selector';
import {
  getFavoriteStore,
  getStoreSpecialList,
} from '@tcp/core/src/components/common/organisms/PickupStoreModal/container/PickUpStoreModal.selectors';
import ProductDetailView from '@tcp/core/src/components/features/browse/ProductDetail/views';
import {
  getProductDetails,
  setProductDetailsDynamicData,
  setProductDetails,
  resetCountUpdated,
  setDisableSelectedTab,
  loadSocialProofData,
  clearSocialProofData,
  setIsSidebarMounted,
  setTabSectionName,
  setSyteScriptLoaded,
  dynamicContentLoader,
  fetchAdditionalPromoModuleX,
  scrollToIndex,
  fetchShippingAndReturnsModuleX,
  fetchSimilarProducts,
  resetSimilarProducts,
  setPlpProductData,
  openSimilarProductsModal,
  closeSimilarProductsModal,
} from '@tcp/core/src/components/features/browse/ProductDetail/container/ProductDetail.actions.js';
import { trackPageView, setClickAnalyticsData, trackClick } from '@tcp/core/src/analytics/actions';
import {
  removeAddToFavoriteErrorState,
  addItemsToWishlist,
  getUserFavt,
  setLastDeletedItemIdAction,
  showToastModal,
} from '@tcp/core/src/components/features/browse/Favorites/container/Favorites.actions';
import {
  getIsShowPriceRange,
  getIsKeepAliveProduct,
  getIsInternationalShipping,
  getABTestIsShowPriceRange,
  getIsCompleteTheLookTestEnabled,
  getABTestAddToBagDrawer,
  getMultiPackThreshold,
  getIsPerUnitPriceEnabled,
  getIsPlpPdpAnchoringEnabled,
  getIsBrierleyPromoEnabled,
  getABTestForPDPColorOrImageSwatchHover,
  getMultiColorNameEnabled,
  getIsDynamicBadgeEnabled,
  getIsDisableDynamicBadgeFlagAbtest,
  getIsPDPSmoothScrollEnabled,
  getIsHiddenPDPAltImageEnabled,
  getAbTestIsFamilyOutfitRightViewEnabled,
  getIsABLoaded,
  getIsShowBrandNameEnabled,
  getAbTestIsVerticalCTLEnabled,
  getAbTestIsVerticalRecommendationsEnabled,
  getABTestIsMiniBagEnabled,
  getIsRedesignedPdpDesktopView,
  getIsAccessoryEnabled,
  getAbTestIsTopRatedBadgeEnabled,
  getAbTestIsBestSellerBackAbTestEnabled,
  getIsNewPlpCardTileEnabled,
  getIsNewPlpImageBorderEnabled,
  getIsNewPJPPDPRedesignEnabled,
  getIsTakeDownRedirectionEnabled,
  getIsColorConsolidationEnabled,
  getIsSyteEnabled,
  getSyteRecommendations,
  getIsSimilarItemToConsiderEnabled,
  getIsTopRatedBadgeEnabledSLP,
  getSortByRatingLabel,
  getIsBIABagPageCustomVariableEnabled,
  getIsHideOriginalPriceAndMarchantTagEnabled,
  getAbTestIsESGBadgePDPBackABEnabled,
  getisQvPdpInfluencerHandleAbTest,
  getAbTestIsMostFavoritedBackAbEnabled,
  getIsPlccPriceOnPDP,
  getOutfitV3Widget,
  getOutfitV3WidgetVDABTest,
  getOutfitV3WidgetMnMABTest,
  getIsStyliticsComposerWidgetEnabled,
  getIsAlsoAvailablePillsDisabled,
  getDynamicContentPDP,
  getIsImageIndicatorUpdateEnabled,
  isPixleeWebEnabled,
  getDynamicPromoPerfSwitch,
  getIsPinchZoomPDPImageEnabled,
  getIsPLCCBannerPriceAbTest,
  getIsPDPRedesignEnabled,
  getInfluencerPicksEnabled,
  getIsBestSellerBadgeEnabledSLP,
  isShopThisStoreModeOn,
  getIsShowPromoPriceMicroData,
  getPlccOfferPercentage,
  getIsUpdatedPromotionsDisplayEnabled,
  getABTestForRcommAboveProdDesc,
  getShowBopisTileBasedOnStoreSpecials,
  getIsRedesignGlobalHeaderEnabled,
  getShowStoreSpecialsV2,
  getIsShippedAndReturnsTabEnabled,
  getIsClickableBrandBadgesEnabled,
  getIsSplittingExtendedSizesEnabled,
  getIsGlobalDefaultHeaderRedesignEnabled,
  getIsSimilarProductsEnabled,
  getIsFinalSaleBackABEnabled,
  getIsPromoMsgEnabledRecommendation,
  getIsOOSSimilarStyleKillSwitch,
  getAddToDefaultFavoritesEnabled,
  getIsLoyaltyTieringEnabled,
  getIsTransparentImageSizeReducedForPdp,
  getIsDyEnabled,
  getIsDyAbTestEnabled,
} from '@tcp/core/src/reduxStore/selectors/session.selectors';
import {
  getSearchTerm,
  getAppliedFilters as getAppliedFiltersSLP,
  getFirstTimeCaptureBanner,
  getFirstTimeCaptureShopMenu,
  getIsBopisFilterOn as getIsBopisFilterOnSlp,
} from '@tcp/core/src/components/features/browse/SearchDetail/container/SearchDetail.selectors';
import {
  getAddedToBagError,
  addedToBagMsgSelector,
  getPDPlargeImageColorSelector,
} from '@tcp/core/src/components/features/CnC/AddedToBag/container/AddedToBag.selectors';
import { getAddedToBagErrorCatId } from '@tcp/core/src/components/features/browse/OutfitDetails/container/OutfitDetails.selectors';

import {
  getNavTree,
  prodDetails,
  getSimilarProducts,
  getDescription,
  getRatingsProductId,
  getDefaultImage,
  getCurrentProduct,
  getShortDescription,
  getGeneralProductId,
  getAlternateSizes,
  getAlternateStyles,
  getPDPTopPromos,
  getPDPMiddlePromos,
  getDynamicContentPromo,
  getPDPBottomPromos,
  getPDPBelowRecsPromos,
  getSizeChartDetails,
  getPDPLoadingState,
  getOnModelImageAbTestPdp,
  getIsAbPdpPlaEnabled,
  getIsOosPdpEnabled,
  isValidProduct,
  getProductInfoFromProductListingData,
  getStyliticsProductTabListSelector,
  getPageUrl,
  getProductInfoFromRecommendationData,
  getProductInfoFromDyRecommendationsData,
  getProductInfoFromModule,
  getProductInfoFromOutfit,
  getProductInfoFromBundle,
  getUpdatedCount,
  getPriceDisplayState,
  getMultiPackProductInfo,
  getMultiPackCount,
  getAllMultiPackData,
  partIdInformation,
  getAllNewMultiPackData,
  getSelectedMultipack,
  getPdpNewRecommendation,
  getIsPdp1andPdp2Enabled,
  getInitialMultipackMapping,
  getInitialColorConsolidationMultipackMapping,
  getInitialAvailableTCPmapNewStyleId,
  getSinglePageLoad,
  getInitialTCPStyleQTY,
  getDisableMultiPackTab,
  getSocialProofMessage,
  getAccessoriesData,
  getIsSidebarMounted,
  getNavBreadCrumbs,
  getActiveTabSection,
  getIsTakeDownProduct,
  getTakeDownCategory,
  getPlpProductData,
  getSlpProductData,
  getAppliedFiltersfromPLP,
  getSyteScriptLoaded,
  getDynamicContentLoader,
  getAdditionalPromoModuleXContentId,
  getAdditionalPromoModuleXContent,
  getShippingAndReturnsModuleXContent,
  getScrollToIndex,
  getIsDeptClicked,
  getCartProductData,
  getProductDetailFormValues,
  getShippingAndReturnsModuleXContentID,
  getSimilarProductsModalStatus,
  getIsVisualSimilarStylesEnabled,
} from '@tcp/core/src/components/features/browse/ProductDetail/container/ProductDetail.selectors';
import {
  getCurrentCurrency,
  getCurrencyAttributes,
} from '@tcp/core/src/reduxStore/selectors/currency.selectors';
import {
  getExternalCampaignFired,
  getCategoryIdPLP,
  getIsBopisFilterOn,
} from '@tcp/core/src/components/features/browse/ProductListing/container/ProductListing.selectors';
import {
  getDyRecommendations,
  getPDP1Rec,
  getPDP2Rec,
  getPDPRecentlyViewed,
  getPDPPLARec,
  getPDPOOSRec,
} from '@tcp/core/src/components/common/molecules/DyRecommendations/container/DyRecommendations.selector';
import {
  fetchDyRecommendationsData,
  sendTrackEventsToDy,
} from '@tcp/core/src/components/common/molecules/DyRecommendations/container/DyRecommendations.actions';
import { getPDPContext } from '@tcp/core/src/services/abstractors/common/recommendations/utils/dyRequestContext.js';
import {
  addToCartEcom,
  clearAddToBagErrorState,
} from '@tcp/core/src/components/features/CnC/AddedToBag/container/AddedToBag.actions';
import { getCartItemInfo } from '@tcp/core/src/components/features/CnC/AddedToBag/util/utility';
import {
  fetchAddToFavoriteErrorMsg,
  wishListFromState,
  getDefaultFavItemInProgressFlag,
  fetchErrorMessages,
  getToastModalState,
} from '@tcp/core/src/components/features/browse/Favorites/container/Favorites.selectors';
import PRODUCTDETAIL_CONSTANTS from '@tcp/core/src/components/features/browse/ProductDetail/container/ProductDetail.constants';
import ProductDetailSkeleton from '@tcp/core/src/components/features/browse/ProductDetail/molecules/ProductDetailSkeleton/index';
import { setExternalCampaignState } from '@tcp/core/src/components/common/molecules/Loader/container/Loader.actions';
import { fetchPageLayout, setPageVisibilityTitle } from '@tcp/core/src/reduxStore/actions';
import processHelperUtil from '@tcp/core/src/services/abstractors/productListing/ProductDetail.util';
import logger from '@tcp/core/src/utils/loggerInstance';
import {
  getSelectedAccessories,
  getAccessories,
  getSecondarySelectedAccessories,
} from '@tcp/core/src/components/common/molecules/Accessories/container/Accessories.selectors';
import {
  openQuickViewWithValues,
  resetPDPDataOfQVProduct,
} from '@tcp/core/src/components/common/organisms/QuickViewModal/container/QuickViewModal.actions';
import { clearAllSelectedAccessories } from '@tcp/core/src/components/common/molecules/Accessories/container/Accessories.actions';
import {
  getBrandName,
  getMapSliceForColor,
  getIsESGBadgeAnalyticsString,
} from '@tcp/core/src/components/features/browse/ProductListing/molecules/ProductList/utils/productsCommonUtils';
import { setProductDataForReview } from '@tcp/core/src/components/features/browse/WriteReviewDetail/container/WriteReview.actions';
import { markPriceIncluded } from '@tcp/core/src/components/common/molecules/Accessories/util/utility';
import Col from '@tcp/core/src/components/common/atoms/Col';
import {
  StyledPDPRecommendationWrapper,
  StyledPdpWrapper,
} from '@tcp/core/src/components/features/browse/ProductDetail/ProductDetail.style';
import debounce from 'lodash/debounce';
import {
  fetchAbTestData,
  fetchDyABTestsData,
} from '@tcp/core/src/components/common/molecules/abTest/abTest.actions';
import {
  getTopRatedBadge,
  getBestSellerBadge,
  getMostFavoriteBadge,
} from '@tcp/core/src/components/features/browse/ProductListing/molecules/ProductList/views/ProductGridItem.util';
import {
  TOP_RATED,
  BEST_SELLER,
  TOP_RATED_ANALYTICS_STRING,
  BEST_SELLER_ANALYTICS_STRING,
  MOST_FAVORITED,
  MOST_FAVORITED_ANALYTICS_STRING,
} from '@tcp/core/src/constants/badge.constants';
import { getBuyItAgainBagPageProducts } from '@tcp/core/src/components/features/CnC/BuyItAgainBagPage/container/BuyItAgainBagPage.actions';
import ApplyCardDynamicStore from '@tcp/core/src/components/features/browse/ApplyCardPage/container/ApplyCardDynamicStore';
import BuyItAgainDynamicStore from '@tcp/core/src/components/features/account/BuyItAgain/container/BuyItAgainDynamicStore';
import { styliticsProductTabListDataSuccess } from '@tcp/core/src/components/common/organisms/StyliticsProductTabList/container/StyliticsProductTabList.actions';
import { setSelectedProductId } from '@tcp/core/src/components/features/browse/OutfitDetails/container/OutfitDetails.actions';
import EmptyPDP from '@tcp/core/src/components/features/account/Orders/molecules/EmptyPDP';
import {
  getDynamicLabelValues,
  getLabelFromCopyOrFromTranslation,
} from '@tcp/core/src/utils/labels/labelUtilty';
import {
  CmnBrowse,
  PdpSub,
  pdpLabels,
} from '@tcp/core/src/components/features/browse/ProductDetail/views/ProductDetail.labels';
import { sendEventsToMonetate } from '@tcp/core/src/components/common/molecules/Recommendations/container/Recommendations.actions';
import {
  getPLCCDiscountValue,
  getStoreSpecialDiscountValue,
  getPromotionsData,
  getDefaultStoreId,
  getServerTimeFromState,
} from '@tcp/core/src/components/common/organisms/Promotions/container/Promotions.selectors';
import dyRequestContextMap from '@tcp/core/src/components/common/molecules/abTest/utils/dyRequestContext';
import getPdpPageData from './productDetails.utils';

// SYTE Vendor Script
const SyteVendorScript = dynamic(() => import('../../../common/vendors/Syte/Syte'));

const LargeDesktopOuterRightContainer = dynamic(
  () =>
    import(
      // eslint-disable-next-line extra-rules/no-commented-out-code
      /* webpackChunkName: "large-desktop-outer-right" */ '@tcp/core/src/components/features/browse/ProductDetail/molecules/LargeDesktopOuterRight'
    ),
  { ssr: false }
);

const WriteReviewContainer = dynamic(
  () =>
    import(
      // eslint-disable-next-line extra-rules/no-commented-out-code
      /* webpackChunkName: "write-review-detail" */ '@tcp/core/src/components/features/browse/WriteReviewDetail/index'
    ),
  { ssr: false }
);
const UploadModal = dynamic(
  () =>
    import(
      // eslint-disable-next-line extra-rules/no-commented-out-code
      /* webpackChunkName: "upload-modal" */ '@tcp/core/src/components/features/browse/WriteReviewDetail/molecules/UploadModal/views/UploadModal.view'
    ),
  { ssr: false }
);
const SubmissionFeedbackModal = dynamic(
  () =>
    import(
      // eslint-disable-next-line extra-rules/no-commented-out-code
      /* webpackChunkName: "submission-feedback" */ '@tcp/core/src/components/features/browse/WriteReviewDetail/molecules/SubmissionFeedback/views/SubmissionFeedbackModal.view'
    ),
  { ssr: false }
);

const imgConfigValArray = {
  moduleG: moduleGConfig,
  moduleJ: moduleJConfig,
};

/**
 * Hotfix-Aware Component. The use of `withRefWrapper` and `withHotfix`
 * below are just for making the page hotfix-aware.
 */
const ProductDetailWithRef = withRefWrapper(ProductDetailView);
ProductDetailWithRef.displayName = 'ProductDetailPage';
const ProductDetail = withHotfix(ProductDetailWithRef);

const setIsBackPage = (pageUrl, id) => {
  return pageUrl && pageUrl === (isClient() && window.location.pathname) && pageUrl.includes(id);
};
const getPageInfo = (props) => {
  const { pageUrl, itemPartNumber } = props;
  const id = itemPartNumber.replace('_', '-');
  return {
    isBackPage: setIsBackPage(pageUrl, id),
    url: isClient() ? window.location.pathname : null,
  };
};

const checkIsNewFitsPresent = (props) => {
  const { isSplittingExtendedSizesEnabled, productInfo } = props;
  const { colorFitsSizesMap } = productInfo || {};
  return (
    isSplittingExtendedSizesEnabled &&
    colorFitsSizesMap?.length > 0 &&
    colorFitsSizesMap[0]?.hasNewFitAttribute
  );
};

const resetProductDetailPage = (
  clearAddToBagError,
  resetProductDetailsDynamicData,
  resetProductDetails
) => {
  clearAddToBagError();
  resetProductDetailsDynamicData();
  resetProductDetails();
};

const getBundleProductState = (state) =>
  state &&
  state.BundleProduct &&
  state.BundleProduct.currentBundle &&
  state.BundleProduct.currentBundle;

const getOutfitProductState = (state) =>
  state &&
  state.OutfitDetails &&
  state.OutfitDetails.currentOutfit &&
  state.OutfitDetails.currentOutfit.products;

class ProductDetailContainer extends React.PureComponent {
  static extractProductIdFromURL = (pid) => {
    const id = pid && pid?.split('-');
    let productId =
      id && id?.length > 1 ? `${id[id?.length - 2]}_${id[id?.length - 1].split('$')[0]}` : pid;
    if (
      (id?.indexOf('Gift') > -1 || id?.indexOf('gift') > -1) &&
      (id?.indexOf('Card') > -1 || id?.indexOf('card') > -1)
    ) {
      productId = 'gift';
    }

    return productId;
  };

  static extractPID = (props) => {
    const {
      router: {
        query: { pid },
      },
    } = props;
    // TODO - fix this to extract the product ID from the page.
    return ProductDetailContainer.extractProductIdFromURL(pid);
  };

  static getInitialProps = async ({ state, store, props }) => {
    const {
      AbTest: { isVerticalRecommendationsEnabled },
    } = state;
    const isDyAbTestEnabled = getIsDyAbTestEnabled();
    if (isVerticalRecommendationsEnabled === undefined && !isDyAbTestEnabled) {
      store.dispatch(fetchAbTestData());
    }
    if (isVerticalRecommendationsEnabled === undefined && isDyAbTestEnabled) {
      const payload = dyRequestContextMap.pdp();
      store.dispatch(fetchDyABTestsData(payload));
    }

    return { props: { ...props } };
  };

  constructor(props) {
    super(props);

    this.state = {
      showRecentlyViewedVerticalView: true,
      showVerticleScrollContainer: false,
      top: 266,
      hasMounted: false,
      isPristineFormValues: true,
    };
    this.pdpLabel = this.getPdpLabels();
    this.modifiedFormData = null;
    this.loadingFlag = !this.props.productDetailsInfoFromQV;
    this.seoRef = React.createRef({});
  }

  static getDerivedStateFromProps = (props, state) => {
    const {
      productListingDetail,
      searchListingDetail,
      recommendationDetail,
      ProductTabList,
      BundleDetails,
      OutfitDetails,
      router: {
        query: { isSearchPage, dataSource = '', viaPage, recommendationSelector },
      },
      plpProductData,
      slpProductData,
      cartProductData,
      isDyEnabled,
      dyRecommendations,
    } = props;
    const dataToCarryForward = parseBoolean(isSearchPage)
      ? searchListingDetail
      : productListingDetail;

    const pid = ProductDetailContainer.extractPID(props);

    const { renderedPid } = state;
    if (pid !== renderedPid && isClient()) {
      if (dataSource === 'newplp') {
        return {
          renderedPid: pid,
          retrievedProductInfo: plpProductData,
        };
      }
      if (dataSource === 'newslp') {
        return {
          renderedPid: pid,
          retrievedProductInfo: slpProductData,
        };
      }
      if (dataSource === 'bag') {
        return {
          renderedPid: pid,
          retrievedProductInfo: cartProductData,
        };
      }
      if (dataSource === 'recommendation' && !isDyEnabled) {
        return {
          renderedPid: pid,
          retrievedProductInfo: getProductInfoFromRecommendationData({
            pid,
            details: recommendationDetail,
            dataSource,
          }),
          imgConfigVal: { imgConfig: null },
        };
      }
      if (dataSource === 'recommendation' && isDyEnabled) {
        return {
          renderedPid: pid,
          retrievedProductInfo: getProductInfoFromDyRecommendationsData({
            pid,
            details: dyRecommendations,
            dataSource,
            page: viaPage,
            recommendationSelector,
          }),
          imgConfigVal: { imgConfig: null },
        };
      }
      if (dataSource.indexOf('module_') !== -1) {
        const dataSourceParts = dataSource.split('_');
        const currentCatId = dataSourceParts[2];
        const moduleName = dataSourceParts[1];
        return {
          renderedPid: pid,
          retrievedProductInfo: getProductInfoFromModule({
            pid,
            details: ProductTabList[currentCatId],
          }),
          imgConfigVal: imgConfigValArray[`module${moduleName}`].IMG_DATA.productImgConfig,
        };
      }
      if (dataSource.indexOf('outfit') !== -1) {
        return {
          renderedPid: pid,
          retrievedProductInfo: getProductInfoFromOutfit({
            pid,
            details: OutfitDetails,
          }),
          imgConfigVal: imageData.imgConfig,
        };
      }
      if (dataSource.indexOf('bundle') !== -1) {
        return {
          renderedPid: pid,
          retrievedProductInfo: getProductInfoFromBundle({
            pid,
            details: BundleDetails,
          }),
          imgConfigVal: imageData.imgConfig,
        };
      }
      return {
        renderedPid: pid,
        retrievedProductInfo: dataToCarryForward
          ? getProductInfoFromProductListingData({
              pid,
              details: dataToCarryForward,
            })
          : null,
      };
    }
    return null;
  };

  state = {
    renderedPid: '',
    retrievedProductInfo: null,
  };

  async componentDidMount() {
    const { props } = this;
    this.setState({ hasMounted: true });
    this.isSidebarEnabled();
    const {
      getHomePageLayout,
      layouts,
      clearSelectedAccessories,
      isAccessoriesEnabled,
      isLoggedIn,
      getBIABagPageProducts,
      isBIAABCustomVariableEnabled,
      isDynamicContentPDPEnabled,
      router,
      dynamicContentLoaderActn,
      dynamicContentPromo,
      isDyEnabled,
      productInfo,
      loadDyRecommendations,
    } = props;
    const tcpPrimaryCategory = router?.query?.tcpPrimaryCategory || '';
    const pid = ProductDetailContainer.extractPID(props);
    const apiConfigObj = getAPIConfig();
    const { loadHomePageDataEnabled, timeOutGap } = apiConfigObj;
    if (!isMobileWeb()) {
      window.scrollTo(0, 0);
      this.getTopPositionForRightRec();
    }
    ProductDetailContainer.getInitialProps({ props });
    if (isBIAABCustomVariableEnabled && isLoggedIn) {
      await BuyItAgainDynamicStore();
      getBIABagPageProducts();
    }
    if (loadHomePageDataEnabled && !layouts.home) {
      const clearLayoutTimeout = setTimeout(() => {
        getHomePageLayout(apiConfigObj);
        clearTimeout(clearLayoutTimeout);
      }, timeOutGap);
    }
    if (isAccessoriesEnabled) {
      clearSelectedAccessories();
    }

    let tcpPrimaryCategoryparsed;
    if (tcpPrimaryCategory === 'null') {
      tcpPrimaryCategoryparsed = JSON.parse(tcpPrimaryCategory);
    } else {
      tcpPrimaryCategoryparsed = tcpPrimaryCategory;
    }

    if (isDynamicContentPDPEnabled && tcpPrimaryCategoryparsed && !dynamicContentPromo) {
      dynamicContentLoaderActn(true);
    }
    prefetchImportantChunks('PDP');

    if (isDyEnabled && pid === productInfo?.generalProductId) {
      const payload = getPDPContext({
        data: [productInfo?.allProductId[0]?.variants[0]?.variantId],
        primaryCategory: productInfo?.primaryCategory,
        outOfStock: this.getOOSFlag(productInfo),
      });
      loadDyRecommendations(payload);
    }

    this.debouncedHandleScroll = debounce(this.getTopPositionForRightRec, 150);
    window.addEventListener('scroll', this.debouncedHandleScroll);
  }
  /*
  shouldComponentUpdate(nextProps, nextState) {
    if (isEqual(nextProps, this.props) && isEqual(nextState, this.state)) {
      return false;
    }
    return true;
  } */

  componentWillUnmount() {
    const { clearSelectedAccessories, isSidebarMounted, resetSimilarProductsActn } = this.props;
    clearSelectedAccessories();
    isSidebarMounted(false);
    resetSimilarProductsActn();
    window.removeEventListener('scroll', this.debouncedHandleScroll);
  }

  componentDidUpdate(prevProps) {
    const {
      onFavtLoad,
      isLoggedIn,
      router: {
        query: { pid },
      },
      itemPartNumber,
      isPlpPdpAnchoringEnabled,
      clearSelectedAccessories,
      isRecommendationSidebar,
      getRecommendationProduct,
      isTakeDownProduct,
      setPageTitle,
      productInfo,
      loadDyRecommendations,
      isDyEnabled,
    } = this.props;
    const { generalProductId, primaryCategory } = productInfo || {};
    const { productInfo: { generalProductId: prevGenProductId } = {} } = prevProps;
    const productId = ProductDetailContainer.extractPID(this.props);
    const apiConfig = getAPIConfig();
    this.prevSearchPage = prevProps.router.query.isSearchPage;
    if (prevProps.router.query.pid !== pid) {
      this.makeApiCall({ productColorId: productId, apiConfig });
      if (isPlpPdpAnchoringEnabled && isMobileWeb()) {
        scrollToBreadCrumb(false, true);
      } else {
        window.scrollTo(0, 100);
      }
      clearSelectedAccessories();
    } else if (itemPartNumber && itemPartNumber !== productId && !isTakeDownProduct) {
      this.makeApiCall({
        productColorId: productId || itemPartNumber,
        apiConfig,
      });
    }
    if (prevProps.isLoggedIn !== isLoggedIn) {
      onFavtLoad(true);
    }

    if (prevProps.isRecommendationSidebar !== isRecommendationSidebar) {
      this.setState({ showVerticleScrollContainer: isRecommendationSidebar });
    }
    if (prevProps.getRecommendationProduct !== getRecommendationProduct) {
      this.isSidebarEnabled();
    }
    if (prevProps.productInfo !== productInfo && this.seoRef.current) {
      setPageTitle(this.seoRef.current?.title);
    }
    if (isDyEnabled && generalProductId && generalProductId !== prevGenProductId) {
      const payload = getPDPContext({
        data: [productInfo?.allProductId[0]?.variants[0]?.variantId],
        primaryCategory,
        outOfStock: this.getOOSFlag(productInfo),
      });
      loadDyRecommendations(payload);
    }
  }

  getPdpLabels = () => {
    const labelsObj1 = getLabelFromCopyOrFromTranslation(PdpSub, pdpLabels);
    const labelsObj2 = getLabelFromCopyOrFromTranslation('PLP.plpTiles', pdpLabels);
    const dynValue = getDynamicLabelValues('dynamic.browse_d.lbl_you_recently_viewed');
    const labelsObj3 = { lbl_you_recently_viewed: dynValue };
    const labelsObj4 = getLabelFromCopyOrFromTranslation('global.Sorting', pdpLabels);
    const labelsObj5 = getLabelFromCopyOrFromTranslation(CmnBrowse, pdpLabels);
    return { ...labelsObj1, ...labelsObj2, ...labelsObj3, ...labelsObj4, ...labelsObj5 };
  };

  shouldScroll = (prevProps, pid, productDetailsInfoFromQV) => {
    const { productInfoQV: prevProductInfoQV } = prevProps?.productDetailsInfoFromQV || {};
    const { productInfoQV } = productDetailsInfoFromQV || {};
    return (
      (prevProps.router.query.pid !== pid && !productInfoQV?.generalProductId) ||
      (productInfoQV && prevProductInfoQV?.generalProductId !== productInfoQV?.generalProductId)
    );
  };

  makeApiCall = (payload) => {
    const {
      getDetails,
      router,
      pageUrl,
      clearAddToBagError,
      resetProductDetailsDynamicData,
      resetProductDetails,
    } = this.props;
    const asPath = (router && router.asPath) || '';
    const tcpPrimaryCategory = router?.query?.tcpPrimaryCategory || '';
    const brandName = getBrandNameFromHref(asPath);
    const [url] = asPath.split('?');
    if (pageUrl && pageUrl !== url) {
      clearAddToBagError();
      resetProductDetailsDynamicData();
      resetProductDetails();
    }
    if ((pageUrl && pageUrl !== url) || !pageUrl) {
      getDetails({
        ...payload,
        ...(isClient() ? { url } : {}),
        otherBrand: brandName,
        tcpPrimaryCategory,
      });
    }
  };

  getSEOTags = (pageId) => {
    const { productInfo, router } = this.props;
    const storeDetails = { labels: this.pdpLabel, productInfo };
    if (pageId) {
      const seoConfig = deriveSEOTags(pageId, storeDetails, router);
      this.seoRef.current = seoConfig;
      return seoConfig ? <SEOTags seoConfig={seoConfig} pageId={pageId} /> : null;
    }
    return null;
  };

  markIncludedAccessory = (accessories, isMandatoryCustomization) => {
    return (
      accessories &&
      accessories.map((accessory, i) => {
        return {
          ...accessory,
          c_priceIncluded: isMandatoryCustomization && i === 0,
        };
      })
    );
  };

  addValueToSessionStorage = ({ key, prodPartNo, value }) => {
    if (isClient()) {
      try {
        const sessionValue = JSON.parse(getSessionStorage(key));
        const stringifiedSV = JSON.stringify({
          ...sessionValue,
          [prodPartNo]: value,
        });
        setSessionStorage({ key, value: stringifiedSV });
      } catch (err) {
        return null;
      }
    }
    return null;
  };

  getIsTopRatedOrBestSeller = ({ type, currentColorEntry, prodPartNo }) => {
    const {
      breadCrumbs,
      currentCategoryIdPLP: currentCategoryIdOldPlp,
      router: {
        query: { isSearchPage },
      },
      plpProductData,
    } = this.props;
    const { categoryId: currentCategoryIdNewPlp } = plpProductData;
    const currentCategoryIdPLP = currentCategoryIdNewPlp || currentCategoryIdOldPlp;
    const isFromPLPPage = this.isFromPLPPage();
    if (isFromPLPPage && !parseBoolean(isSearchPage) && breadCrumbs.length > 1) {
      const badge1 = currentColorEntry?.miscInfo?.badge1;
      const isTopRated = getTopRatedBadge(badge1, true, currentCategoryIdPLP);
      const isBestSeller = getBestSellerBadge(badge1, true, currentCategoryIdPLP);
      const isMostFavorite = getMostFavoriteBadge(badge1, true, currentCategoryIdPLP);

      if (type === TOP_RATED && isTopRated) {
        this.addValueToSessionStorage({
          key: TOP_RATED,
          prodPartNo,
          value: TOP_RATED_ANALYTICS_STRING,
        });
        return TOP_RATED_ANALYTICS_STRING;
      }

      if (type === BEST_SELLER && isBestSeller) {
        this.addValueToSessionStorage({
          key: BEST_SELLER,
          prodPartNo,
          value: BEST_SELLER_ANALYTICS_STRING,
        });
        return BEST_SELLER_ANALYTICS_STRING;
      }
      if (type === MOST_FAVORITED && isMostFavorite) {
        this.addValueToSessionStorage({
          key: MOST_FAVORITED,
          prodPartNo,
          value: MOST_FAVORITED_ANALYTICS_STRING,
        });
        return MOST_FAVORITED_ANALYTICS_STRING;
      }
    }
    return '';
  };

  getIsColorConsolidatedProduct = ({
    productInfo,
    prodPartNo,
    initialColorConsolidationMultipackMapping,
  }) => {
    return (
      productInfo?.allProductId?.find((product) => product.productid === prodPartNo)
        ?.color_consolidated_product ||
      initialColorConsolidationMultipackMapping.includes(prodPartNo) ||
      false
    );
  };

  getTakeDownCartItemsInfo = ({
    isTakeDownRedirectionEnabled,
    isTakeDownProduct,
    renderedPid,
    prodPartNo,
    takeDownCategory,
    cartItemInfo,
    isColorConsolidatedProduct,
    colorInfo,
  }) => {
    let takeDownCartItemInfo;
    if (isTakeDownRedirectionEnabled && isTakeDownProduct) {
      let cd158;
      if (isColorConsolidatedProduct) {
        cd158 = `${renderedPid}>ALSO AVAILABLE IN|${takeDownCategory}|COLOR|${colorInfo}|${prodPartNo}`;
        takeDownCartItemInfo = {
          ...cartItemInfo,
          cd158,
        };
      } else {
        cd158 = `${renderedPid}>ALSO AVAILABLE IN|${takeDownCategory}|${prodPartNo}`;
        takeDownCartItemInfo = {
          ...cartItemInfo,
          cd158,
        };
      }
      this.addValueToSessionStorage({
        key: 'colorConsolidation',
        prodPartNo,
        value: cd158,
      });
    }
    return takeDownCartItemInfo || cartItemInfo;
  };

  getNullSearchAnalyticsString = ({ alternateBrand, prodPartNo }) => {
    const {
      router: {
        query: { isSearchPage, isFromSearchPageQV },
      },
    } = this.props;
    if ((isSearchPage || isFromSearchPageQV) && alternateBrand) {
      const prodBrand = getBrandInCaps();
      const cd122 = `${prodBrand}>${alternateBrand.toUpperCase()}|null search`;
      this.addValueToSessionStorage({
        key: 'nullSearch',
        prodPartNo,
        value: cd122,
      });
      return { cd122 };
    }
    return '';
  };

  constructTopRateBestSellerCartInfo = ({
    productInfo,
    formValues,
    isTopRatedBadgeEnabled,
    prodPartNo,
    cartItemInfo,
    isBestSellerBackAbEnabled,
    isMostFavoritedBadgeEnabled,
  }) => {
    let newCartItemInfo = cartItemInfo;
    const currentColorEntry = getMapSliceForColor(productInfo.colorFitsSizesMap, formValues.color);
    if (!isTopRatedBadgeEnabled) {
      const cd108 = this.getIsTopRatedOrBestSeller({
        type: TOP_RATED,
        currentColorEntry,
        prodPartNo,
      });
      newCartItemInfo = {
        ...cartItemInfo,
        cd108,
      };
    }

    if (!isBestSellerBackAbEnabled) {
      const cd109 = this.getIsTopRatedOrBestSeller({
        type: BEST_SELLER,
        currentColorEntry,
        prodPartNo,
      });
      newCartItemInfo = {
        ...cartItemInfo,
        cd109,
      };
    }
    if (!isMostFavoritedBadgeEnabled) {
      const cd139 = this.getIsTopRatedOrBestSeller({
        type: MOST_FAVORITED,
        currentColorEntry,
        prodPartNo,
      });
      newCartItemInfo = {
        ...newCartItemInfo,
        cd139,
      };
    }

    return newCartItemInfo;
  };

  constructESGBadgeAnalyticsString = ({ backAB, allProductId, colorDisplayId }) => {
    const cd135 = getIsESGBadgeAnalyticsString({
      backAB,
      allProductId,
      colorDisplayId,
    });

    if (cd135) {
      this.addValueToSessionStorage({
        key: 'esgBadges',
        prodPartNo: colorDisplayId,
        value: cd135,
      });
    }

    return cd135;
  };

  handleAddToBag = () => {
    const {
      addToBagEcom,
      formValues,
      productInfo,
      multipackProduct,
      multiPackCount,
      getAllMultiPack,
      showAddtoBagDrawer,
      partIdInfo,
      getAllNewMultiPack,
      selectedMultipack,
      router,
      accessories,
      secondaryAccessories,
      accessoriesData,
      isColorConsolidationEnabled,
      initialColorConsolidationMultipackMapping,
      isTopRatedBadgeEnabled,
      isBestSellerBackAbEnabled,
      isTakeDownRedirectionEnabled,
      isTakeDownProduct,
      takeDownCategory,
      isESGBadgePDPBackABEnabled,
      isMostFavoritedBadgeEnabled,
    } = this.props;
    const { renderedPid } = this.state;
    const asPath = router && router.asPath;
    const brandName = getBrandNameFromHref(asPath);
    let params;
    if (typeof window !== 'undefined') {
      params = new URLSearchParams(window.location.search);
    }
    const queryParams = params?.get('fromBIA');
    const queryParamsBday = params?.get('fromBIRTHDAY');
    const cd66 = JSON.parse(getSessionStorage('biaDimension'))?.dimension66;
    const cd81 = JSON.parse(getSessionStorage('bdayDimension'))?.dimension81;
    const biaDimension = queryParams && cd66 ? cd66 : '';
    const bdayDimension = queryParamsBday && cd81 ? cd81 : '';
    const primaryBrand =
      getBrandName(productInfo?.primaryBrand, productInfo?.alternateBrand) || brandName;
    const productInfoAccessoryData = productInfo?.accessoriesData?.customizationType;
    const isMandatoryCustomization =
      productInfoAccessoryData === 'mandatory' ||
      accessoriesData?.customizationType === 'mandatory';
    let cartItemInfo = getCartItemInfo(productInfo, formValues);
    const modifiedAccessories = markPriceIncluded(
      accessories,
      secondaryAccessories,
      isMandatoryCustomization
    );
    const prodPartNo = cartItemInfo?.skuInfo?.prodPartNo;
    const isColorConsolidatedProduct = this.getIsColorConsolidatedProduct({
      productInfo,
      prodPartNo,
      initialColorConsolidationMultipackMapping,
    });
    const colorInfo = cartItemInfo?.skuInfo?.color?.name?.split('-')?.[0];
    if (isColorConsolidationEnabled) {
      const productName = productInfo?.allProductId?.find(
        (product) => product.productid === prodPartNo
      )?.style_name;

      if (productName) {
        cartItemInfo = {
          ...cartItemInfo,
          productName,
        };
      }
      if (isColorConsolidatedProduct && !isTakeDownProduct) {
        const productId = cartItemInfo?.skuInfo?.productId;
        const cd158 = `${productId}>COLOR|${colorInfo}|${prodPartNo}`;
        this.addValueToSessionStorage({
          key: 'colorConsolidation',
          prodPartNo,
          value: cd158,
        });
        cartItemInfo = {
          ...cartItemInfo,
          cd158,
        };
      }
    }
    cartItemInfo = this.constructTopRateBestSellerCartInfo({
      productInfo,
      formValues,
      isTopRatedBadgeEnabled,
      prodPartNo,
      cartItemInfo,
      isBestSellerBackAbEnabled,
      isMostFavoritedBadgeEnabled,
    });
    cartItemInfo = this.getTakeDownCartItemsInfo({
      isTakeDownRedirectionEnabled,
      isTakeDownProduct,
      renderedPid,
      prodPartNo,
      takeDownCategory,
      cartItemInfo,
      isColorConsolidatedProduct,
      colorInfo,
    });

    const cd122 = this.getNullSearchAnalyticsString({ alternateBrand: brandName, prodPartNo });

    const cd135 = this.constructESGBadgeAnalyticsString({
      backAB: isESGBadgePDPBackABEnabled,
      allProductId: productInfo?.allProductId,
      colorDisplayId: prodPartNo,
    });

    cartItemInfo = {
      ...cartItemInfo,
      isPdpPage: true,
      dimension66: biaDimension,
      dimension81: bdayDimension,
      originPage: this.prevSearchPage ? 'spdp' : 'pdp',
      multipackProduct,
      multiPackCount,
      getAllMultiPack,
      skipAddToBagModal: showAddtoBagDrawer,
      partIdInfo,
      getAllNewMultiPack,
      selectedMultipack,
      primaryBrand,
      alternateBrand: brandName,
      accessories: modifiedAccessories,
      bossDisabledFlags: productInfo?.colorFitsSizesMap?.[0]?.miscInfo?.bossDisabledFlags,
      ...cd122,
      cd135,
    };
    addToBagEcom(cartItemInfo);
  };

  getNavigateTypeParam = () => {
    const { router } = this.props;
    return getObjectValue(router, '', 'query', 'navigateType', 'components');
  };

  checkIfFromPLPorSLP = () => {
    const { router } = this.props;
    if (!isServer() && router.components) {
      const isProductListing =
        Object.prototype.hasOwnProperty.call(router.components, '/ProductListing') ||
        Object.prototype.hasOwnProperty.call(router.components, '/CategoryListingPage');
      const isSearchPage = Object.prototype.hasOwnProperty.call(router.components, '/SearchDetail');
      return isProductListing || isSearchPage;
    }
    return false;
  };

  getRouterAttr = () => {
    const { router } = this.props;
    let routeObj = {};
    if (!isServer() && router.components) {
      const productDetailPage = router.components['/ProductDetail'] || {};
      const { query: { referer = '', isSearchPage = '' } = {} } = productDetailPage;
      routeObj = { referer, isSearchPage };
    }
    return routeObj;
  };

  isFromPLPPage = () => {
    const routeAttr = this.getRouterAttr();
    if (routeAttr.referer === 'categoryPage') return true;
    return false;
  };

  isFromSLPPage = () => {
    const routeAttr = this.getRouterAttr();
    if (routeAttr.isSearchPage === 'true') return true;
    return false;
  };

  isProductAvailable = () => {
    const { productInfo, itemPartNumber, isTakeDownProduct } = this.props;
    const productId = ProductDetailContainer.extractPID(this.props);
    const productInfoLengthCheck = Object.keys(productInfo).length > 0;
    return isTakeDownProduct
      ? productInfoLengthCheck
      : productInfoLengthCheck && productId?.split('$')[0] === itemPartNumber?.split('$')[0];
  };

  getOOSFlag = (productInfo) => {
    const { colorFitsSizesMap, tcpMultiPackReferenceUSStore, multiPackUSStore } = productInfo;
    const filteredColorFitsList =
      colorFitsSizesMap && colorFitsSizesMap.filter((item) => item.maxAvailable === 0);

    if (
      (colorFitsSizesMap && colorFitsSizesMap.length) ===
        (filteredColorFitsList && filteredColorFitsList.length) &&
      !(tcpMultiPackReferenceUSStore && multiPackUSStore)
    ) {
      return true;
    }
    return false;
  };

  openModal = (e) => {
    e.preventDefault();
    requestAnimationFrame(async () => {
      await ApplyCardDynamicStore();
      const { toggleModal } = this.props;
      toggleModal({ isModalOpen: true });
    });
  };

  // Vertical recomendations
  updateShowRecentlyViewedVertically = () => {
    this.setState({ showRecentlyViewedVerticalView: true });
  };

  getGlobalDefaultHeaderRedesignTopValue = ({ header, atbHeader }) => {
    let top = 0;
    const headerTopPromo = document.getElementsByClassName('header-top-nav-promo-block')[0];

    if (window.pageYOffset === 0) {
      top = headerTopPromo
        ? headerTopPromo.offsetHeight + header?.offsetHeight
        : header?.offsetHeight;
    } else if (atbHeader) {
      top = header?.offsetHeight + atbHeader?.offsetHeight;
    } else if (!atbHeader && window.pageYOffset !== 0) {
      const headerOffsetHeight = headerTopPromo
        ? headerTopPromo.offsetHeight + header?.offsetHeight
        : header?.offsetHeight;
      const scrollDiff = headerOffsetHeight - window.pageYOffset;
      const stickyTopVal =
        window.pageYOffset > headerOffsetHeight ? headerOffsetHeight : scrollDiff;
      top = stickyTopVal;
    }
    return top;
  };

  setTopValForVerticalRecommendations = ({ atbHeader, condensedHeader, header }) => {
    if (atbHeader) {
      this.setState({ top: atbHeader.offsetHeight });
    } else if (condensedHeader) {
      this.setState({ top: condensedHeader.offsetHeight });
    } else if (header && !condensedHeader) {
      this.setState({ top: header.offsetHeight - window.pageYOffset });
    } else {
      this.setState({ top: header?.offsetHeight });
    }
  };

  getTopPositionForRightRec = () => {
    const { isGlobalHeaderRedesignEnabled, isGlobalDefaultHeaderRedesignEnabled } = this.props;
    const { showVerticleScrollContainer } = this.state;
    const isMobile =
      ExecutionEnvironment.canUseDOM && document.body.offsetWidth < breakpoints.values.lg;

    if (!isClient() || !showVerticleScrollContainer || isMobile) return;

    // eslint-disable-next-line prefer-destructuring
    const condensedHeader = document.getElementsByClassName('condensed-header')[0];
    const atbHeader = document.getElementsByClassName('sticky-atb-header-container')[0];
    const header = document.getElementsByClassName('header-global')[0];

    if (isGlobalHeaderRedesignEnabled || isGlobalDefaultHeaderRedesignEnabled) {
      const top = this.getGlobalDefaultHeaderRedesignTopValue({ header, atbHeader });
      this.setState({ top });
    }
    if (!isGlobalHeaderRedesignEnabled && !isGlobalDefaultHeaderRedesignEnabled) {
      this.setTopValForVerticalRecommendations({ atbHeader, condensedHeader, header });
    }
  };

  isSidebarEnabled = () => {
    const {
      isVerticalRecommendationsEnabled,
      isMiniBagEnabled,
      isFamilyOutfitRightViewEnabled,
      isVerticalCTLEnabled,
      isSidebarMounted,
      getRecommendationProduct,
    } = this.props;
    if (
      (isVerticalRecommendationsEnabled && getRecommendationProduct?.length > 0) ||
      isMiniBagEnabled ||
      isFamilyOutfitRightViewEnabled ||
      isVerticalCTLEnabled
    ) {
      isSidebarMounted(true);
      this.setState({ showVerticleScrollContainer: true });
    }
  };

  getVerticalViewFlagStateBasedOnPriority = () => {
    const {
      isVerticalRecommendationsEnabled,
      isMiniBagEnabled,
      isFamilyOutfitRightViewEnabled,
      isVerticalCTLEnabled,
    } = this.props;
    // Since current priority order is: isVerticalRecommendationsEnabled > isMiniBagEnabled > isFamilyOutfitEnabled > isVerticalCTLEnabled
    if (isVerticalRecommendationsEnabled) {
      return {
        isVerticalRecommendationsEnabled,
        isMiniBagEnabled: false,
        isFamilyOutfitRightViewEnabled: false,
        isVerticalCTLEnabled: false,
      };
    }
    if (isMiniBagEnabled) {
      return {
        isVerticalRecommendationsEnabled,
        isMiniBagEnabled,
        isFamilyOutfitRightViewEnabled: false,
        isVerticalCTLEnabled: false,
      };
    }
    if (isFamilyOutfitRightViewEnabled) {
      return {
        isVerticalRecommendationsEnabled,
        isMiniBagEnabled,
        isFamilyOutfitRightViewEnabled,
        isVerticalCTLEnabled: false,
      };
    }
    return {
      isVerticalRecommendationsEnabled,
      isMiniBagEnabled,
      isFamilyOutfitRightViewEnabled,
      isVerticalCTLEnabled,
    };
  };

  renderVerticalRecommendations = () => {
    const { productDetails, checkForOOSForVariant } = this.props;
    const { showRecentlyViewedVerticalView, showVerticleScrollContainer } = this.state;

    if (isClient() && showVerticleScrollContainer && getViewportInfo().isLargeDesktop) {
      return (
        <Col
          className="right-scroll-container-wrapper"
          colSize={{ small: false, medium: false, large: 2 }}
        >
          <LargeDesktopOuterRightContainer
            showRecentlyViewedVerticalView={showRecentlyViewedVerticalView}
            triggerStylyticsAnalytics={this.triggerStylyticsAnalytics}
            checkForOOSForVariant={checkForOOSForVariant}
            productDetails={productDetails}
            {...this.props}
          />
        </Col>
      );
    }
    return null;
  };

  renderSeoSection = ({ productInfo }) => {
    const seoTags =
      ProductDetailContainer.pageInfo.pageId && productInfo
        ? this.getSEOTags(ProductDetailContainer.pageInfo.pageId, this.pdpLabel)
        : null;

    const seoProps = seoTags && seoTags.props && seoTags.props.seoConfig;
    return (
      <>
        <NextSeo {...seoProps} />
        <Head>
          {seoProps &&
            seoProps.hrefLangs?.length > 0 &&
            (() => {
              const canonical = seoProps.canonical || '';

              const filteredLangs = seoProps.hrefLangs.filter((lang) => {
                const langCountry = lang.canonicalUrl?.split?.('/')[3] || '';
                const canonicalCountry = canonical.split?.('/')[3] || '';
                return lang.id === 'x-default' || canonicalCountry === langCountry;
              });
              const hasXDefault = seoProps.hrefLangs.some((l) => l.id === 'x-default');
              return (
                <>
                  {filteredLangs.map((lang) => (
                    <link
                      key={lang.id}
                      rel="alternate"
                      hrefLang={lang.id}
                      href={lang.canonicalUrl}
                    />
                  ))}

                  {!hasXDefault && canonical && (
                    <link rel="alternate" hrefLang="x-default" href={canonical} />
                  )}
                </>
              );
            })()}
        </Head>
      </>
    );
  };

  renderWriteReview = (isWriteReviewModalOpen) => {
    if (isWriteReviewModalOpen) {
      return <WriteReviewContainer />;
    }
    return null;
  };

  renderUploadModal = (isAddPhotoModalOpen, isAddVideoModalOpen) => {
    return isAddPhotoModalOpen || isAddVideoModalOpen ? (
      <UploadModal className="new-write-review-upload-modal" />
    ) : null;
  };

  renderSubmissionFeedbackModal = (isSubmissionFeedbackModalOpen) => {
    return isSubmissionFeedbackModalOpen ? (
      <SubmissionFeedbackModal className="new-write-review-submission-feedback-modal" />
    ) : null;
  };

  getAspectRatioFromImage = (image, defaultAspectRatio) => {
    return image
      ? {
          aspect_ratio_d: image?.aspect_ratio_d || '28',
          aspect_ratio_m: image?.aspect_ratio_m || '98',
          aspect_ratio_t: image?.aspect_ratio_t || '38',
        }
      : defaultAspectRatio;
  };

  getAspectRatioFromObject = (mediaData, defaultAspectRatio) => {
    const aspectRatioObject = mediaData
      ? this.getAspectRatioFromImage(mediaData, defaultAspectRatio)
      : defaultAspectRatio;
    return getAspectRatio(aspectRatioObject);
  };

  getMediaData = (dynamicContentPromo) => {
    if (
      dynamicContentPromo?.largeCompImageCarousel &&
      dynamicContentPromo?.largeCompImageCarousel[0]?.linkedImage &&
      dynamicContentPromo?.largeCompImageCarousel[0]?.linkedImage[0]
    ) {
      const linkedImage = dynamicContentPromo.largeCompImageCarousel[0].linkedImage[0];
      return linkedImage.image || linkedImage.video;
    }
    return null;
  };

  memo = {};

  getAlternateStyleBasedOnSelectedColor = (allProductId, generalProductId) => {
    const key = generalProductId;

    if (!this.memo[key]) {
      this.memo[key] = processHelperUtil.getAlternateStyleBasedOnSelectedColor(
        allProductId,
        generalProductId
      );
    }

    return this.memo[key];
  };

  // eslint-disable-next-line complexity, sonarjs/cognitive-complexity
  getIsBopisFilterCheck = (isBopisFilterOnPlp, isBopisFilterOnSlp) => {
    return isShopThisStoreModeOn() || isBopisFilterOnPlp || isBopisFilterOnSlp;
  };

  render() {
    const {
      productDetails,
      breadCrumbs,
      longDescription,
      itemPartNumber,
      shortDescription,
      ratingsProductId,
      defaultImage,
      productInfo,
      currency,
      currencyAttributes,
      addToBagError,
      onAddItemToFavorites,
      isLoggedIn,
      isPlcc,
      alternateSizes,
      isShowPriceRangeKillSwitch,
      showPriceRangeForABTest,
      AddToFavoriteErrorMsg,
      removeAddToFavoritesErrorMsg,
      topPromos,
      middlePromos,
      dynamicContentPromo,
      bottomPromos,
      belowrecsPromos,
      isLoading,
      trackPageLoad,
      sizeChartDetails,
      isKeepAliveEnabled,
      pageProps,
      defaultWishListFromState,
      storeId,
      resetCountUpdate,
      countUpdated,
      isCompleteTheLookTestEnabled,
      hidePriceDisplay,
      addBtnMsg,
      multiPackCount,
      multiPackThreshold,
      multipackProduct,
      partIdInfo,
      getAllNewMultiPack,
      getDetails,
      getRecommendationProduct,
      isBrierleyPromoEnabled,
      isOosPdpEnabled,
      isPdpNewRecommendationEnabled,
      isPdp1andPdp2Enabled,
      largeImageNameOnHover,
      hasABTestForPDPColorOrImageSwatchHover,
      initialMultipackMapping,
      setInitialTCPStyleQty,
      resetProductDetailsDynamicData,
      onSetLastDeletedItemIdAction,
      deleteFavItemInProgressFlag,
      disableMultiPackTab,
      getDisableSelectedTab,
      istMultiColorNameEnabled,
      isDynamicBadgeEnabled,
      isDynamicBadgeEnabledAbtest,
      isPDPSmoothScrollEnabled,
      isHiddenPDPAltImageEnabled,
      socialProofMessage,
      getSocialProofData,
      isFamilyOutfitEnabled,
      errorMessages,
      isABTestLoaded,
      isShowBrandNameEnabled,
      isFamilyOutfitRightViewEnabled,
      accessoriesData,
      isVerticalCTLEnabled,
      isDefaultBreadCrumb,
      accessories,
      allAccessories,
      appliedFiltersPLP,
      appliedFiltersSLP,
      secondarySelectedAccessoryList,
      trackWishListClick,
      isVerticalRecommendationsEnabled,
      setProductDataForReviewActn,
      isWriteReviewModalOpen,
      isAddPhotoModalOpen,
      isAddVideoModalOpen,
      isSubmissionFeedbackModalOpen,
      isMiniBagEnabled,
      isAddBgdToTransparentImgEnabled,
      isSyteEnabled,
      syteRecommendations,
      isSyteScriptLoaded,
      plpProductData,
      currentCategoryIdPLP,
      onSetSyteScriptLoaded,
      isNewPJPPDPRedesignEnabled,
      isSimilarItemToConsiderEnabled,
      sortByRatingLabel,
      closeBirthdayRecommandationDrawer,
      isBMModalOpen,
      isHideOriginalPriceAndMarchantTagEnabled,
      isPlccPriceOnPDP,
      showToastModalAction,
      toastModalState,
      outfitV3WidgetEnabled,
      outfitV3WidgetVDABTestEnabled,
      outfitV3WidgetMnMABTest,
      isStyliticsComposerWidgetEnabled,
      setSelectedProductIdForOutfit,
      isDynamicContentPDPEnabled,
      IsImageIndicatorUpdateEnabled,
      isPixleeWidget,
      showDynamicContentLoader,
      dynamicPromoPerfSwitch,
      isPLCCBannerPriceEnabled,
      isPDPRedesignEnabled,
      isInfluencerPicksEnabled,
      isBestSellerBadgeEnabledSLP,
      additionalPromoModuleXContentId,
      fetchAdditionalPromoModule,
      additionalPromoModuleXContent,
      isBopisFilterOnPlp,
      isBopisFilterOnSlp,
      setPdpTabSectionIndex,
      activeTabIndex,
      productDetailsInfoFromQV,
      resetQVProductActn,
      formValues,
      isDeptClicked,
      plccOfferPercentage,
      isUpdatedPromotionsDisplayEnabled,
      isStoreSpecialsPriceOn,
      storeSpecialDiscount,
      activePromotions,
      defaultStoreId,
      sendEventsToMonetateActn,
      fetchShippingAndReturnsModule,
      shippingAndReturnsModuleXContent,
      isShippedAndReturnsTabEnabled,
      shippingAndReturnsModuleXContentID,
      isClickableBrandBadgesEnabled,
      fetchSimilarProductsActn,
      isAISimilarStyleEnabled,
      initializeFormValueActn,
      saveProductDataForPdp,
      isOOSSimilarStyleEnabled,
      serverTime,
      resetSimilarProductsActn,
      addToDefaultFavoritesEnabled,
      isTransparentImageSizeReduceEnabledForPdp,
      isDyEnabled,
      dyPdp1Recommendations,
      dyPdp2Recommendations,
      dyPdpRecentlyViewedRecommendations,
      dyPDPPLARec,
      dyPDPOOSRec,
      sendTrackEventsToDyAction,
      ...otherProps
    } = this.props;
    const { productInfoQV, formValuesQV } = productDetailsInfoFromQV || {};
    const {
      router: {
        query: { isSearchPage, dataSource = '' },
      },
    } = this.props;
    const checkForOOSForAllVariantsFlag = this.getOOSFlag(productInfo);
    const {
      retrievedProductInfo,
      renderedPid,
      imgConfigVal,
      showRecentlyViewedVerticalView,
      showVerticleScrollContainer,
      hasMounted,
    } = this.state;
    const { categoryId: currentCategoryIdNewPlp } = plpProductData;
    const { router: { asPath: asPathVal } = {} } = this.props;
    const brandName = getBrandNameFromHref(asPathVal);
    const productDetailsQV = productInfoQV && {
      currentProduct: productInfoQV,
      currentProductDynamicData: {},
    };
    const isProductDataAvailable = this.isProductAvailable();
    const navigateType = this.getNavigateTypeParam();
    const getPriceRange = isShowPriceRangeKillSwitch
      ? parseBoolean(isShowPriceRangeKillSwitch)
      : false;
    const getABTestPriceRange = showPriceRangeForABTest;

    const fromPLPPage = this.checkIfFromPLPorSLP();
    const isFromPLPPage = this.isFromPLPPage();
    const isFromSLPPage = this.isFromSLPPage();
    const verticalViewFlags = this.getVerticalViewFlagStateBasedOnPriority();
    this.getTopPositionForRightRec();

    // Syte Script
    const Syte = isSyteEnabled ? SyteVendorScript : () => null;
    const SyteRecommendations =
      !isSyteEnabled && syteRecommendations?.isSyteEnabled ? SyteVendorScript : () => null;

    const showDynamicContentLoaderCheck =
      showDynamicContentLoader && dynamicPromoPerfSwitch && isDynamicContentPDPEnabled;

    const defaultAspectRatio = {
      aspect_ratio_d: '28',
      aspect_ratio_m: '98',
      aspect_ratio_t: '38',
    };

    const mediaData = this.getMediaData(dynamicContentPromo);
    const isBopisFilterOn = this.getIsBopisFilterCheck(isBopisFilterOnPlp, isBopisFilterOnSlp);
    const aspectRatioObjNew = this.getAspectRatioFromObject(mediaData, defaultAspectRatio);

    let isProductDataAvailableValue;
    let isValidProductValue;
    let itemPartNumberValue;
    let productInfoValue;
    let isLoadingValue;
    let checkForOOSForVariantValue;
    let longDescriptionValue;
    let alternateStylesValue;
    let formValuesData;
    const fvQv = formValuesQV && Array.isArray(formValuesQV) ? formValuesQV[0] : formValuesQV;
    let formSizeValue = null;
    let formColorValue = null;
    let formFitValue = null;

    // Extract fit value from formValues
    if (formValues?.fit) {
      formFitValue = typeof formValues.fit === 'object' ? formValues.fit.name : formValues.fit;
    }
    // Extract size value from formValues
    if (formValues && formValues.size) {
      if (typeof formValues.size === 'object') {
        formSizeValue = formValues.size.name;
      } else {
        formSizeValue = formValues.size;
      }
    }
    // Extract color value from formValues
    if (formValues && formValues.color) {
      if (typeof formValues.color === 'object') {
        formColorValue = formValues.color.name;
      } else {
        formColorValue = formValues.color;
      }
    }
    // initializing redux form
    if (productInfoQV && itemPartNumber && itemPartNumber === productInfoQV?.generalProductId) {
      const formName = `ProductAddToBag-${itemPartNumber}`;
      const { color, fit, size } = fvQv;
      initializeFormValueActn({
        formName,
        values: {
          color: { name: color || '' },
          Quantity: 1,
          Fit: fit ? { name: fit } : null,
          Size: { name: size || '' },
        },
      });
    }
    if (fvQv?.color) this.modifiedFormData = fvQv;
    /**
     * adding isPristineFormValues check, to check if the formValues change or not, this is only for the case
     * when user is navigating from QV to PDP and data from QV is carry-forwarded to PDP.
     * this check is to fix the ELO-15105, where when user navigating from QV to PDP,
     * and try to change the color of the Product on PDP.
     */
    if (
      (this.modifiedFormData?.color && this.modifiedFormData?.color !== formColorValue) ||
      (this.modifiedFormData?.size && this.modifiedFormData?.size !== formSizeValue) ||
      (this.modifiedFormData?.fit && this.modifiedFormData?.fit !== formFitValue)
    ) {
      formValuesData = { ...this.modifiedFormData };
    } else {
      formValuesData = { ...formValues };
      this.modifiedFormData = null;
    }
    const {
      imageConfigWithoutDPR = '',
      dynamicBadgeOverlayQty,
      isFromHeroProductTile,
    } = retrievedProductInfo || {};
    const isProductLoaded =
      !productInfoQV ||
      productInfoQV?.generalProductId === 'gift' ||
      productInfoQV?.generalProductId === itemPartNumber;
    if (isProductDataAvailable && isProductLoaded && this.loadingFlag) {
      isProductDataAvailableValue = isProductDataAvailable;
      isValidProductValue = isValidProduct;
      itemPartNumberValue = itemPartNumber;
      productInfoValue = productInfo;
      isLoadingValue = isLoading;
      checkForOOSForVariantValue = checkForOOSForAllVariantsFlag;
      longDescriptionValue = longDescription;
      if (productInfoQV && productInfoQV.generalProductId === itemPartNumber) {
        resetQVProductActn();
      } else {
        this.modifiedFormData = null;
      }
    } else if (productInfoQV) {
      isProductDataAvailableValue = true;
      isValidProductValue = true;
      itemPartNumberValue = productInfoQV.generalProductId;
      productInfoValue = productInfoQV;
      isLoadingValue = false;
      checkForOOSForVariantValue = false;
      longDescriptionValue = productInfoQV.longDescription;
      alternateStylesValue = this.getAlternateStyleBasedOnSelectedColor(
        productInfoQV.allProductId,
        productInfoQV.generalProductId
      );
    }
    const fromBagPage = dataSource === 'bag';
    this.loadingFlag = true;
    return (
      <>
        {this.renderSeoSection({ productInfo })}
        <StyledPDPRecommendationWrapper top={this.state.top}>
          <StyledPdpWrapper
            showVerticleScrollContainer={showVerticleScrollContainer}
            isNewPJPPDPRedesignEnabled={isNewPJPPDPRedesignEnabled}
          >
            {isProductDataAvailableValue ? (
              <ProductDetail
                {...otherProps}
                formValues={formValuesData}
                productInfoQV={productInfoQV}
                isProductDataAvailable={isProductDataAvailableValue}
                alternateStylesFromQV={alternateStylesValue}
                isValidProduct={isValidProductValue}
                productDetails={productDetailsQV || productDetails}
                breadCrumbs={breadCrumbs}
                itemPartNumber={itemPartNumberValue}
                longDescription={longDescriptionValue}
                shortDescription={shortDescription}
                openModal={this.openModal}
                ratingsProductId={ratingsProductId}
                defaultImage={defaultImage}
                currency={currency}
                currencyAttributes={currencyAttributes}
                productInfo={productInfoValue}
                handleAddToBag={this.handleAddToBag}
                addToBagError={addToBagError}
                onAddItemToFavorites={onAddItemToFavorites}
                isLoggedIn={isLoggedIn}
                isPlcc={isPlcc}
                alternateSizes={alternateSizes}
                isShowPriceRangeKillSwitch={getPriceRange}
                showPriceRangeForABTest={getABTestPriceRange}
                AddToFavoriteErrorMsg={AddToFavoriteErrorMsg}
                removeAddToFavoritesErrorMsg={removeAddToFavoritesErrorMsg}
                asPathVal={asPathVal}
                topPromos={topPromos}
                middlePromos={middlePromos}
                dynamicContentPromo={dynamicContentPromo}
                isDynamicContentPDPEnabled={isDynamicContentPDPEnabled}
                bottomPromos={bottomPromos}
                belowrecsPromos={belowrecsPromos}
                trackPageLoad={trackPageLoad}
                sizeChartDetails={sizeChartDetails}
                isLoading={isLoadingValue}
                hidePriceDisplay={hidePriceDisplay}
                isMatchingFamily // TODO: Need to add kill switch for this
                renderedPid={renderedPid}
                isKeepAliveEnabled={isKeepAliveEnabled}
                navigateType={navigateType}
                wishList={defaultWishListFromState}
                storeId={storeId}
                imgConfigVal={imgConfigVal}
                resetCountUpdate={resetCountUpdate}
                getSocialProofData={getSocialProofData}
                countUpdated={countUpdated}
                isCompleteTheLookTestEnabled={isCompleteTheLookTestEnabled}
                addBtnMsg={addBtnMsg}
                multiPackThreshold={multiPackThreshold}
                multiPackCount={multiPackCount}
                multipackProduct={multipackProduct}
                partIdInfo={partIdInfo}
                getAllNewMultiPack={getAllNewMultiPack}
                getDetails={getDetails}
                isRecommendationAvailable={getRecommendation(getRecommendationProduct)}
                checkForOOSForVariant={checkForOOSForVariantValue}
                isBrierleyPromoEnabled={isBrierleyPromoEnabled}
                isOosPdpEnabled={isOosPdpEnabled}
                isPdpNewRecommendationEnabled={isPdpNewRecommendationEnabled}
                isPdp1andPdp2Enabled={isPdp1andPdp2Enabled}
                largeImageNameOnHover={largeImageNameOnHover}
                hasABTestForPDPColorOrImageSwatchHover={hasABTestForPDPColorOrImageSwatchHover}
                initialMultipackMapping={initialMultipackMapping}
                setInitialTCPStyleQty={setInitialTCPStyleQty}
                resetProductDetailsDynamicData={resetProductDetailsDynamicData}
                onSetLastDeletedItemIdAction={onSetLastDeletedItemIdAction}
                deleteFavItemInProgressFlag={deleteFavItemInProgressFlag}
                disableMultiPackTab={disableMultiPackTab}
                getDisableSelectedTab={getDisableSelectedTab}
                istMultiColorNameEnabled={istMultiColorNameEnabled}
                isDynamicBadgeEnabled={isDynamicBadgeEnabled}
                isDynamicBadgeEnabledAbtest={isDynamicBadgeEnabledAbtest}
                fromPLPPage={fromPLPPage}
                isFromPLPPage={isFromPLPPage}
                isFromSLPPage={isFromSLPPage}
                isPDPSmoothScrollEnabled={isPDPSmoothScrollEnabled}
                socialProofMessage={socialProofMessage}
                isFamilyOutfitEnabled={isFamilyOutfitEnabled}
                errorMessages={errorMessages}
                isABTestLoaded={isABTestLoaded}
                isNewPDPEnabled
                isShowBrandNameEnabled={isShowBrandNameEnabled}
                primaryBrand={productInfo && productInfo.primaryBrand}
                alternateBrand={brandName}
                isHiddenPDPAltImageEnabled={isHiddenPDPAltImageEnabled}
                accessoriesData={accessoriesData}
                previousSearchPage={this.prevSearchPage}
                isDefaultBreadCrumb={isDefaultBreadCrumb}
                accessories={accessories}
                allAccessories={allAccessories}
                appliedFiltersPLP={appliedFiltersPLP}
                appliedFiltersSLP={appliedFiltersSLP}
                secondarySelectedAccessoryList={secondarySelectedAccessoryList}
                trackWishListClick={trackWishListClick}
                isVerticalRecommendationsEnabled={isVerticalRecommendationsEnabled}
                setProductDataForReviewActn={setProductDataForReviewActn}
                updateShowRecentlyViewedVertically={this.updateShowRecentlyViewedVertically}
                showRecentlyViewedVerticalView={showRecentlyViewedVerticalView}
                showVerticleScrollContainer={showVerticleScrollContainer}
                getRecommendationProduct={getRecommendationProduct}
                getSimilarItemToConsider={getSimilarItemToConsiderFromRecommendation(
                  getRecommendationProduct
                )}
                isSyteEnabled={isSyteEnabled}
                syteRecommendations={syteRecommendations}
                isSyteScriptLoaded={isSyteScriptLoaded}
                isAddBgdToTransparentImgEnabled={isAddBgdToTransparentImgEnabled}
                currentCategoryIdPLP={currentCategoryIdNewPlp || currentCategoryIdPLP}
                {...verticalViewFlags}
                isNewPJPPDPRedesignEnabled={isNewPJPPDPRedesignEnabled}
                isSimilarItemToConsiderEnabled={isSimilarItemToConsiderEnabled}
                sortByRatingLabel={sortByRatingLabel}
                closeBirthdayModal={closeBirthdayRecommandationDrawer}
                isBMModalOpen={isBMModalOpen}
                isHideOriginalPriceAndMarchantTagEnabled={isHideOriginalPriceAndMarchantTagEnabled}
                isPlccPriceOnPDP={isPlccPriceOnPDP}
                showToastModalAction={showToastModalAction}
                toastModalState={toastModalState}
                outfitV3WidgetEnabled={outfitV3WidgetEnabled}
                outfitV3WidgetVDABTestEnabled={outfitV3WidgetVDABTestEnabled}
                outfitV3WidgetMnMABTest={outfitV3WidgetMnMABTest}
                isStyliticsComposerWidgetEnabled={isStyliticsComposerWidgetEnabled}
                setSelectedProductIdForOutfit={setSelectedProductIdForOutfit}
                IsImageIndicatorUpdateEnabled={IsImageIndicatorUpdateEnabled}
                isPixleeWidget={isPixleeWidget}
                showDynamicContentLoader={showDynamicContentLoaderCheck}
                aspectRatioObjNew={aspectRatioObjNew}
                dynamicPromoPerfSwitch={dynamicPromoPerfSwitch}
                isPLCCBannerPriceEnabled={isPLCCBannerPriceEnabled}
                isPDPRedesignEnabled={isPDPRedesignEnabled}
                isInfluencerPicksEnabled={isInfluencerPicksEnabled}
                isBestSellerBadgeEnabledSLP={isBestSellerBadgeEnabledSLP}
                additionalPromoModuleXContentId={additionalPromoModuleXContentId}
                fetchAdditionalPromoModule={fetchAdditionalPromoModule}
                additionalPromoModuleXContent={additionalPromoModuleXContent}
                isBopisFilterOn={isBopisFilterOn}
                setPdpTabSectionIndex={setPdpTabSectionIndex}
                activeTabIndex={activeTabIndex}
                plccOfferPercentage={plccOfferPercentage}
                isUpdatedPromotionsDisplayEnabled={isUpdatedPromotionsDisplayEnabled}
                imageConfigWithoutDPR={imageConfigWithoutDPR}
                isStoreSpecialsPriceOn={isStoreSpecialsPriceOn}
                storeSpecialDiscount={storeSpecialDiscount}
                activePromotions={activePromotions}
                fromBagPage={fromBagPage}
                dynamicBadgeOverlayQty={dynamicBadgeOverlayQty}
                defaultStoreId={defaultStoreId}
                sendEventsToMonetateActn={sendEventsToMonetateActn}
                fetchShippingAndReturnsModule={fetchShippingAndReturnsModule}
                shippingAndReturnsModuleXContent={shippingAndReturnsModuleXContent}
                isShippedAndReturnsTabEnabled={isShippedAndReturnsTabEnabled}
                shippingAndReturnsModuleXContentID={shippingAndReturnsModuleXContentID}
                isClickableBrandBadgesEnabled={isClickableBrandBadgesEnabled}
                isFromHeroProductTile={isFromHeroProductTile}
                fetchSimilarProductsActn={fetchSimilarProductsActn}
                isAISimilarStyleEnabled={isAISimilarStyleEnabled}
                saveProductDataForPdp={saveProductDataForPdp}
                isOOSSimilarStyleEnabled={isOOSSimilarStyleEnabled}
                serverTime={serverTime}
                resetSimilarProductsActn={resetSimilarProductsActn}
                addToDefaultFavoritesEnabled={addToDefaultFavoritesEnabled}
                isTransparentImageSizeReduceEnabledForPdp={
                  isTransparentImageSizeReduceEnabledForPdp
                }
                isDyEnabled={isDyEnabled}
                dyPdp1Recommendations={dyPdp1Recommendations}
                dyPdp2Recommendations={dyPdp2Recommendations}
                dyPdpRecentlyViewedRecommendations={dyPdpRecentlyViewedRecommendations}
                dyPDPPLARec={dyPDPPLARec}
                dyPDPOOSRec={dyPDPOOSRec}
                sendTrackEventsToDyAction={sendTrackEventsToDyAction}
              />
            ) : null}
            {!isProductDataAvailableValue && isLoading ? (
              <ProductDetailSkeleton
                retrievedProductInfo={retrievedProductInfo}
                breadCrumbs={breadCrumbs}
                ratingsProductId={ratingsProductId}
                pdpLabels={this.pdpLabel}
                isKeepAliveEnabled={isKeepAliveEnabled}
                productInfo={productInfo}
                currencyAttributes={currencyAttributes}
                currency={currency}
                imgConfigVal={imgConfigVal}
                isShowPriceRangeKillSwitch={getPriceRange}
                showPriceRangeForABTest={getABTestPriceRange}
                largeImageNameOnHover={largeImageNameOnHover}
                hasABTestForPDPColorOrImageSwatchHover={hasABTestForPDPColorOrImageSwatchHover}
                isDynamicBadgeEnabled={isDynamicBadgeEnabled}
                isDynamicBadgeEnabledAbtest={isDynamicBadgeEnabledAbtest}
                fromPLPPage={fromPLPPage}
                wishList={defaultWishListFromState}
                isPDPSmoothScrollEnabled={isPDPSmoothScrollEnabled}
                isFamilyOutfitEnabled={isFamilyOutfitEnabled}
                primaryBrand={retrievedProductInfo && retrievedProductInfo.primaryBrand}
                alternateBrand={brandName}
                isHiddenPDPAltImageEnabled={isHiddenPDPAltImageEnabled}
                isDefaultBreadCrumb={isDefaultBreadCrumb}
                isNewPJPPDPRedesignEnabled={isNewPJPPDPRedesignEnabled}
                isShowBrandNameEnabled={isShowBrandNameEnabled}
                isHideOriginalPriceAndMarchantTagEnabled={isHideOriginalPriceAndMarchantTagEnabled}
                isSearchPage={isSearchPage}
                IsImageIndicatorUpdateEnabled={IsImageIndicatorUpdateEnabled}
                isPixleeWidget={isPixleeWidget}
                showDynamicContentLoader={showDynamicContentLoaderCheck}
                aspectRatioObjNew={aspectRatioObjNew}
                isPDPRedesignEnabled={isPDPRedesignEnabled}
                isDeptClicked={isDeptClicked}
                plccOfferPercentage={plccOfferPercentage}
                isUpdatedPromotionsDisplayEnabled={isUpdatedPromotionsDisplayEnabled}
                isStoreSpecialsPriceOn={isStoreSpecialsPriceOn}
                storeSpecialDiscount={storeSpecialDiscount}
                activePromotions={activePromotions}
                fromBagPage={fromBagPage}
                isClickableBrandBadgesEnabled={isClickableBrandBadgesEnabled}
                dynamicBadgeOverlayQty={dynamicBadgeOverlayQty}
                addToDefaultFavoritesEnabled={addToDefaultFavoritesEnabled}
                isTransparentImageSizeReduceEnabledForPdp={
                  isTransparentImageSizeReduceEnabledForPdp
                }
                isLoggedIn={isLoggedIn}
              />
            ) : null}
            {!isProductDataAvailable && !isLoading && (
              <div>
                <EmptyPDP />
              </div>
            )}
          </StyledPdpWrapper>
          {this.renderVerticalRecommendations()}
        </StyledPDPRecommendationWrapper>
        {this.renderWriteReview(isWriteReviewModalOpen)}
        {this.renderUploadModal(isAddPhotoModalOpen, isAddVideoModalOpen)}
        {this.renderSubmissionFeedbackModal(isSubmissionFeedbackModalOpen)}
        {/* syte and SyteRecommendations is purely client side */}
        {hasMounted && <Syte onScriptLoaded={onSetSyteScriptLoaded} />}
        {hasMounted && <SyteRecommendations onScriptLoaded={onSetSyteScriptLoaded} />}
      </>
    );
  }
}

ProductDetailContainer.pageInfo = {
  pageId: 'p',
  pageData: {
    pageName: 'product',
    pageSection: 'product',
    pageSubSection: 'product',
    loadAnalyticsOnload: false,
  },
};

const isHomeBreadCrumb = (breadCrumbs) =>
  breadCrumbs &&
  breadCrumbs[0] &&
  breadCrumbs[0].displayName === PRODUCTDETAIL_CONSTANTS.FIRST_BREAD_CRUMB;

function mapStateToProps(state, ownProps) {
  const { router } = ownProps;
  const { query } = ownProps.router || {};
  const breadCrumbs = getNavBreadCrumbs(state, query);
  const isDefaultBreadCrumb = isHomeBreadCrumb(breadCrumbs);
  const { User } = state;
  return {
    navTree: getNavTree(state),
    isLoading: getPDPLoadingState(state),
    productDetails: prodDetails(state),
    breadCrumbs: getNavBreadCrumbs(state, query),
    longDescription: getDescription(state),
    itemPartNumber: getGeneralProductId(state),
    shortDescription: getShortDescription(state),
    ratingsProductId: getRatingsProductId(state),
    // This is just to check if the product is correct
    defaultImage: getDefaultImage(state),
    productInfo: getCurrentProduct(state),
    isValidProduct: isValidProduct(state),
    currency: getCurrentCurrency(state),
    currencyAttributes: getCurrencyAttributes(state),
    addToBagError: getAddedToBagError(state),
    addToBagErrorId: getAddedToBagErrorCatId(state),
    formValues: getProductDetailFormValues(state),
    isLoggedIn: getUserLoggedInState(state) && !isRememberedUser(state),
    isPlcc: isPlccUser(state),
    alternateSizes: getAlternateSizes(state),
    alternateStyles: getAlternateStyles(state),
    isShowPriceRangeKillSwitch: getIsShowPriceRange(state),
    isNewPLPAtbCardTileEnabled: getIsNewPlpCardTileEnabled(state),
    isNewPLPImageBorderEnabled: getIsNewPlpImageBorderEnabled(state),
    isNewPJPPDPRedesignEnabled: getIsNewPJPPDPRedesignEnabled(state),
    showPriceRangeForABTest: getABTestIsShowPriceRange(state),
    isKeepAliveEnabled: getIsKeepAliveProduct(state),
    isKeepAliveProduct: getIsKeepAliveProduct(state),
    AddToFavoriteErrorMsg: fetchAddToFavoriteErrorMsg(state),
    topPromos: getPDPTopPromos(state),
    middlePromos: getPDPMiddlePromos(state),
    dynamicContentPromo: getDynamicContentPromo(state),
    bottomPromos: getPDPBottomPromos(state),
    belowrecsPromos: getPDPBelowRecsPromos(state),
    sizeChartDetails: getSizeChartDetails(state),
    isOnModelAbTestPdp: getOnModelImageAbTestPdp(state),
    isAbPdpPlaEnabled: getIsAbPdpPlaEnabled(state),
    isVisualSimilarStylesEnabled: getIsVisualSimilarStylesEnabled(state),
    isOosPdpEnabled: getIsOosPdpEnabled(state),
    completeLookSlotTile: getStyliticsProductTabListSelector(state),
    productListingDetail:
      state &&
      state.ProductListing.cacheUntil &&
      state.ProductListing &&
      state.ProductListing.loadedProductsPages,
    searchListingDetail:
      state && state.SearchListingPage && state.SearchListingPage.loadedProductsPages,
    recommendationDetail: state && state.Recommendations,
    ProductTabList: state && state.ProductTabList,
    BundleDetails: getBundleProductState(state),
    OutfitDetails: getOutfitProductState(state),
    isInternationalShipping: getIsInternationalShipping(state),
    defaultWishListFromState: wishListFromState(state),
    showAddtoBagDrawer: getABTestAddToBagDrawer(state), // show added to bag flash CTA for PDP
    pageUrl: getPageUrl(state),
    searchedText: getSearchTerm(state),
    storeId: getDefaultStore(state) || getFavoriteStore(state),
    countUpdated: getUpdatedCount(state),
    isExternalCampaignFired: getExternalCampaignFired(state),
    isCompleteTheLookTestEnabled: getIsCompleteTheLookTestEnabled(state),
    hidePriceDisplay: getPriceDisplayState(state),
    addBtnMsg: addedToBagMsgSelector(state),
    isDefaultBreadCrumb,
    multipackProduct: getMultiPackProductInfo(state),
    multiPackCount: getMultiPackCount(state),
    multiPackThreshold: getMultiPackThreshold(state),
    getAllMultiPack: getAllMultiPackData(state),
    partIdInfo: partIdInformation(state),
    getAllNewMultiPack: getAllNewMultiPackData(state),
    selectedMultipack: getSelectedMultipack(state),
    isPerUnitPriceEnabled: getIsPerUnitPriceEnabled(state),
    getRecommendationProduct: getProducts(state, 'pdp'),
    isPlpPdpAnchoringEnabled: getIsPlpPdpAnchoringEnabled(state),
    isBrierleyPromoEnabled: getIsBrierleyPromoEnabled(state),
    isPdpNewRecommendationEnabled: getPdpNewRecommendation(state),
    isPdp1andPdp2Enabled: getIsPdp1andPdp2Enabled(state),
    largeImageNameOnHover: getPDPlargeImageColorSelector(state),
    hasABTestForPDPColorOrImageSwatchHover: getABTestForPDPColorOrImageSwatchHover(state),
    initialMultipackMapping: getInitialMultipackMapping(state),
    initialColorConsolidationMultipackMapping: getInitialColorConsolidationMultipackMapping(state),
    setInitialTCPStyleQty: getInitialTCPStyleQTY(state),
    singlePageLoad: getSinglePageLoad(state),
    deleteFavItemInProgressFlag: getDefaultFavItemInProgressFlag(state),
    disableMultiPackTab: getDisableMultiPackTab(state),
    istMultiColorNameEnabled: getMultiColorNameEnabled(state),
    isDynamicBadgeEnabled: getIsDynamicBadgeEnabled(state),
    isDynamicBadgeEnabledAbtest: getIsDisableDynamicBadgeFlagAbtest(state),
    layouts: state.Layouts,
    availableTCPmapNewStyleId: getInitialAvailableTCPmapNewStyleId(state),
    isPDPSmoothScrollEnabled: getIsPDPSmoothScrollEnabled(state),
    isHiddenPDPAltImageEnabled: getIsHiddenPDPAltImageEnabled(state),
    socialProofMessage: getSocialProofMessage(state),
    isFamilyOutfitEnabled: true,
    errorMessages: fetchErrorMessages(state),
    isABTestLoaded: getIsABLoaded(state),
    isShowBrandNameEnabled: getIsShowBrandNameEnabled(state),
    accessories: getSelectedAccessories(state),
    secondaryAccessories: getSecondarySelectedAccessories(state),
    isFamilyOutfitRightViewEnabled: getAbTestIsFamilyOutfitRightViewEnabled(state),
    accessoriesData: getAccessoriesData(state),
    isVerticalCTLEnabled: getAbTestIsVerticalCTLEnabled(state),
    allAccessories: getAccessories(state),
    appliedFiltersPLP: getAppliedFiltersfromPLP(state, query),
    appliedFiltersSLP: getAppliedFiltersSLP(state),
    secondarySelectedAccessoryList: getSecondarySelectedAccessories(state),
    isMiniBagEnabled: getABTestIsMiniBagEnabled(state),
    firstTouchBannerFromHP: getFirstTimeCaptureBanner(state),
    firstTouchShopMenu: getFirstTimeCaptureShopMenu(state),
    isVerticalRecommendationsEnabled: getAbTestIsVerticalRecommendationsEnabled(state),
    isWriteReviewModalOpen: getIsWriteReviewModalOpen(state),
    isAddPhotoModalOpen: getIsAddPhotoModalOpen(state),
    isAddVideoModalOpen: getIsAddVideoModalOpen(state),
    isSubmissionFeedbackModalOpen: getIsSubmissionFeedbackModalOpen(state),
    isRedesignedPdpDesktopView: getIsRedesignedPdpDesktopView(state),
    isAccessoriesEnabled: getIsAccessoryEnabled(state),
    isTopRatedBadgeEnabled: getAbTestIsTopRatedBadgeEnabled(state),
    isBestSellerBackAbEnabled: getAbTestIsBestSellerBackAbTestEnabled(state),
    currentCategoryIdPLP: getCategoryIdPLP(state),
    isRecommendationSidebar: getIsSidebarMounted(state),
    activeTabSection: getActiveTabSection(state),
    isTakeDownProduct: getIsTakeDownProduct(state),
    takeDownCategory: getTakeDownCategory(state),
    isTakeDownRedirectionEnabled: getIsTakeDownRedirectionEnabled(state),
    isColorConsolidationEnabled: getIsColorConsolidationEnabled(state),
    plpProductData: getPlpProductData(state),
    slpProductData: getSlpProductData(state),
    cartProductData: getCartProductData(state),
    isAddBgdToTransparentImgEnabled: getAddBgdToTransparentImgEnabled(state),
    isSyteEnabled: getIsSyteEnabled(state),
    userId: getUserId(state),
    syteRecommendations: getSyteRecommendations(state),
    isSyteScriptLoaded: getSyteScriptLoaded(state),
    isSimilarItemToConsiderEnabled: getIsSimilarItemToConsiderEnabled(state),
    sortByRatingLabel: getSortByRatingLabel(state),
    isTopRatedBadgeEnabledSLP: getIsTopRatedBadgeEnabledSLP(state),
    isBMModalOpen: getDrawerSet(state),
    isBIAABCustomVariableEnabled: getIsBIABagPageCustomVariableEnabled(state),
    isHideOriginalPriceAndMarchantTagEnabled: getIsHideOriginalPriceAndMarchantTagEnabled(state),
    isESGBadgePDPBackABEnabled: getAbTestIsESGBadgePDPBackABEnabled(state),
    isQvPdpInfluencerHandleAbTest: getisQvPdpInfluencerHandleAbTest(state),
    isMostFavoritedBadgeEnabled: getAbTestIsMostFavoritedBackAbEnabled(state),
    isInfluencerPicksEnabled: getInfluencerPicksEnabled(state),
    isPlccPriceOnPDP: getIsPlccPriceOnPDP(state),
    pageData: getPdpPageData(router),
    User,
    APIConfig: getAPIConfigForAdobe(state),
    session: getSessionDataForAdobe(state),
    toastModalState: getToastModalState(state),
    outfitV3WidgetEnabled: getOutfitV3Widget(state),
    outfitV3WidgetVDABTestEnabled: getOutfitV3WidgetVDABTest(state),
    outfitV3WidgetMnMABTest: getOutfitV3WidgetMnMABTest(state),
    isStyliticsComposerWidgetEnabled: getIsStyliticsComposerWidgetEnabled(state),
    disableAlsoAvailablePills: getIsAlsoAvailablePillsDisabled(state),
    isDynamicContentPDPEnabled: getDynamicContentPDP(state),
    IsImageIndicatorUpdateEnabled: getIsImageIndicatorUpdateEnabled(state),
    isPixleeWidget: isPixleeWebEnabled(state),
    showDynamicContentLoader: getDynamicContentLoader(state),
    dynamicPromoPerfSwitch: getDynamicPromoPerfSwitch(state),
    isPinchZoomPDPImageEnabled: getIsPinchZoomPDPImageEnabled(state),
    isPLCCBannerPriceEnabled: getIsPLCCBannerPriceAbTest(state),
    isPDPRedesignEnabled: getIsPDPRedesignEnabled(state),
    isBestSellerBadgeEnabledSLP: getIsBestSellerBadgeEnabledSLP(state),
    additionalPromoModuleXContentId: getAdditionalPromoModuleXContentId(),
    additionalPromoModuleXContent: getAdditionalPromoModuleXContent(state),
    isBopisFilterOnPlp: getIsBopisFilterOn(state),
    isBopisFilterOnSlp: getIsBopisFilterOnSlp(state),
    activeTabIndex: getScrollToIndex(state),
    isShowPromoPriceMicroData: getIsShowPromoPriceMicroData(state),
    productDetailsInfoFromQV: getQVProductData(state),
    isDeptClicked: getIsDeptClicked(state),
    plccOfferPercentage: getPLCCDiscountValue(state) || getPlccOfferPercentage(state),
    isUpdatedPromotionsDisplayEnabled: getIsUpdatedPromotionsDisplayEnabled(state),
    isRcommAboveProdDesc: getABTestForRcommAboveProdDesc(state),
    isStoreSpecialsPriceOn: getShowBopisTileBasedOnStoreSpecials(state),
    storeSpecialDiscount: getStoreSpecialDiscountValue(state),
    activePromotions: getPromotionsData(state),
    isGlobalHeaderRedesignEnabled: getIsRedesignGlobalHeaderEnabled(state),
    defaultStoreId: getDefaultStoreId(state),
    storeSpecialList: getStoreSpecialList(state),
    storeSpecialV2Enabled: getShowStoreSpecialsV2(state),
    shippingAndReturnsModuleXContentID: getShippingAndReturnsModuleXContentID(),
    shippingAndReturnsModuleXContent: getShippingAndReturnsModuleXContent(state),
    isShippedAndReturnsTabEnabled: getIsShippedAndReturnsTabEnabled(state),
    isClickableBrandBadgesEnabled: getIsClickableBrandBadgesEnabled(state),
    isSplittingExtendedSizesEnabled: getIsSplittingExtendedSizesEnabled(state),
    isGlobalDefaultHeaderRedesignEnabled: getIsGlobalDefaultHeaderRedesignEnabled(),
    similarProducts: getSimilarProducts(state),
    isSimilarProductsModalOpen: getSimilarProductsModalStatus(state),
    isAISimilarStyleEnabled: getIsSimilarProductsEnabled(state),
    isFinalSaleMessageEnabled: getIsFinalSaleBackABEnabled(state),
    serverTime: getServerTimeFromState(state),
    isPromoMsgEnabledRecommendation: getIsPromoMsgEnabledRecommendation(state),
    isOOSSimilarStyleEnabled: getIsOOSSimilarStyleKillSwitch(state),
    addToDefaultFavoritesEnabled: getAddToDefaultFavoritesEnabled(state),
    isTransparentImageSizeReduceEnabledForPdp: getIsTransparentImageSizeReducedForPdp(state),
    isLoyaltyTieringEnabled: getIsLoyaltyTieringEnabled(state),
    isDyEnabled: getIsDyEnabled(),
    dyRecommendations: getDyRecommendations(state),
    dyPdp1Recommendations: getPDP1Rec(state),
    dyPdp2Recommendations: getPDP2Rec(state),
    isDyAbTestEnabled: getIsDyAbTestEnabled(),
    dyPdpRecentlyViewedRecommendations: getPDPRecentlyViewed(state),
    dyPDPPLARec: getPDPPLARec(state),
    dyPDPOOSRec: getPDPOOSRec(state),
  };
}

function mapDispatchToProps(dispatch) {
  return {
    toggleModal: (payload) => {
      dispatch(toggleApplyNowModal(payload));
    },
    resetProductDetailsDynamicData: () => dispatch(setProductDetailsDynamicData({ product: {} })),
    resetProductDetails: () => dispatch(setProductDetails({ product: {} })),
    getDetails: (payload) => {
      dispatch(getProductDetails(payload));
    },
    onFavtLoad: (payload) => {
      dispatch(getUserFavt(payload));
    },
    addToBagEcom: (payload) => {
      dispatch(addToCartEcom(payload));
    },
    clearAddToBagError: () => {
      dispatch(clearAddToBagErrorState());
    },
    onAddItemToFavorites: (payload) => {
      dispatch(addItemsToWishlist(payload));
    },
    removeAddToFavoritesErrorMsg: (payload) => {
      dispatch(removeAddToFavoriteErrorState(payload));
    },
    setExternalCampaignFired: (payload) => {
      dispatch(setExternalCampaignState(payload));
    },
    trackPageLoad: (payload) => {
      const { products, customEvents, productId, pageSearchType, storeId, ...restPayload } =
        payload;
      dispatch(setClickAnalyticsData(payload));
      dispatch(
        trackPageView({
          props: {
            initialProps: {
              pageProps: {
                pageData: {
                  products,
                  ...restPayload,
                },
              },
            },
          },
        })
      );
    },
    trackClick: (payload) => {
      dispatch(setClickAnalyticsData(payload));
      const timer = setTimeout(() => {
        dispatch(trackClick(payload));
        clearTimeout(timer);
      }, 500);
    },
    trackClickWithoutDelay: (payload) => {
      dispatch(setClickAnalyticsData(payload));
      dispatch(trackClick(payload));
    },
    resetCountUpdate: (payload) => {
      dispatch(resetCountUpdated(payload));
    },
    onSetLastDeletedItemIdAction: (payload) => {
      dispatch(setLastDeletedItemIdAction(payload));
    },
    getDisableSelectedTab: (payload) => {
      dispatch(setDisableSelectedTab(payload));
    },
    getHomePageLayout: (apiConfig) => {
      dispatch(fetchPageLayout({ pageName: 'home', apiConfig }));
    },
    onQuickViewOpenClick: (payload) => {
      dispatch(openQuickViewWithValues(payload));
    },
    getSocialProofData: (action) => {
      dispatch(clearSocialProofData(action));
      dispatch(loadSocialProofData(action));
    },
    clearSelectedAccessories: () => {
      dispatch(clearAllSelectedAccessories());
    },
    trackWishListClick: (payload) => {
      dispatch(setClickAnalyticsData(payload));
      dispatch(trackClick());
    },
    setProductDataForReviewActn: (payload) => dispatch(setProductDataForReview(payload)),
    isSidebarMounted: (payload) => dispatch(setIsSidebarMounted(payload)),
    setPdpTabSectionName: (payload) => {
      dispatch(setTabSectionName(payload));
    },
    setPdpTabSectionIndex: (payload) => dispatch(scrollToIndex(payload)),
    onSetSyteScriptLoaded: (payload) => {
      dispatch(setSyteScriptLoaded(payload));
    },
    closeBirthdayRecommandationDrawer: (action) => {
      dispatch(OpenBirthdayRecommandationDrawer(action));
    },
    getBIABagPageProducts: () => dispatch(getBuyItAgainBagPageProducts()),
    showToastModalAction: (payload) => {
      dispatch(showToastModal(payload));
    },
    setStyliticsProductTabListData: (payload) => {
      dispatch(styliticsProductTabListDataSuccess(payload));
    },
    saveProductDataForPdp: (payload) => {
      dispatch(setPlpProductData(payload));
    },
    setSelectedProductIdForOutfit: (payload) => dispatch(setSelectedProductId(payload)),
    dynamicContentLoaderActn: (payload) => dispatch(dynamicContentLoader(payload)),
    fetchAdditionalPromoModule: (payload) => {
      dispatch(fetchAdditionalPromoModuleX(payload));
    },
    resetQVProductActn: () => dispatch(resetPDPDataOfQVProduct()),
    sendEventsToMonetateActn: (action) => {
      dispatch(sendEventsToMonetate(action));
    },
    fetchShippingAndReturnsModule: (payload) => dispatch(fetchShippingAndReturnsModuleX(payload)),
    fetchSimilarProductsActn: (payload) => dispatch(fetchSimilarProducts(payload)),
    resetSimilarProductsActn: (payload) => dispatch(resetSimilarProducts(payload)),
    openSimilarProductsModalActn: (payload) => dispatch(openSimilarProductsModal(payload)),
    closeSimilarProductsModalActn: (payload) => dispatch(closeSimilarProductsModal(payload)),
    initializeFormValueActn: ({ formName, values }) => {
      dispatch(initialize(formName, values));
    },
    setPageTitle: (payload) => dispatch(setPageVisibilityTitle(payload)),
    loadDyRecommendations: (payload) => {
      dispatch(fetchDyRecommendationsData(payload));
    },
    sendTrackEventsToDyAction: (payload) => {
      dispatch(sendTrackEventsToDy(payload));
    },
  };
}

function resetPDPCondition(productInfo) {
  return isClient() && productInfo && !productInfo.isSSRData;
}

ProductDetailContainer.getInitialProps = async (
  { props: passedProps, store, isServer: isServerReq, query, req, res, apiConfig },
  { setResStatusNotFound } = {}
  // eslint-disable-next-line sonarjs/cognitive-complexity
) => {
  const props = passedProps || {
    ...mapStateToProps(store.getState()),
    ...mapDispatchToProps(store.dispatch),
  };

  let config;
  if (isServerReq) {
    config = res.locals.apiConfig;
  } else {
    config = getAPIConfig();
  }

  const { unbxdUrl, unbxdSiteKey, unbxdApiKey } = config;
  const originalURL = `${unbxdUrl}/${unbxdApiKey}/${unbxdSiteKey}`;

  const {
    getDetails,
    clearAddToBagError,
    resetProductDetailsDynamicData,
    resetProductDetails,
    productInfo,
    router,
    multiPackCount,
  } = props;

  let pid;
  if (isServerReq) {
    ({ pid } = query);
  } else {
    ({
      router: {
        query: { pid },
      },
    } = props);
  }

  // TODO - fix this to extract the product ID from the page.
  let productId = ProductDetailContainer.extractPID({
    ...props,
    router: { query: { pid } },
  });
  const isBotDevice = getIfBotDevice(req);

  const { url, isBackPage } = getPageInfo(props);
  const asPath = router && router.asPath;
  const brandName = getBrandNameFromHref(asPath);
  const isNewFitsPresent = checkIsNewFitsPresent(props);
  if ((!isBackPage || multiPackCount || isNewFitsPresent) && isClient()) {
    if (resetPDPCondition(productInfo)) {
      resetProductDetailPage(
        clearAddToBagError,
        resetProductDetailsDynamicData,
        resetProductDetails
      );
    }
    if (!productId) {
      const path = window?.location?.pathname;
      const prodId = path?.split('/')?.pop();
      productId = ProductDetailContainer.extractProductIdFromURL(prodId);
    }
    const tcpPrimaryCategory = router?.query?.tcpPrimaryCategory;
    let storeId = JSON.parse(getLocalStorage('defaultStore'))?.basicInfo?.id;
    if (storeId) {
      storeId = storeId?.substring(2);
    }
    logger.info(`Making call to unbxd for product id: ${productId}`);
    await new Promise((resolve) =>
      getDetails({
        productColorId: productId,
        escapeEmptyProduct: true,
        resolve,
        isBotDevice,
        url,
        originalURL,
        apiConfig,
        otherBrand: brandName,
        tcpPrimaryCategory,
        storeId,
      })
    );
  }
  // Build a page name for tracking
  if (store && !isValidProduct(store.getState()) && setResStatusNotFound) {
    setResStatusNotFound();
  }
  let pageName = '';
  if (productId) {
    const productIdParts = productId.split('_');
    pageName = `product:${productIdParts[0]}:${(pid || '')
      .replace(productIdParts[0], '')
      .replace(productIdParts[1], '')
      .split('-')
      .join(' ')
      .trim()
      .toLowerCase()}`;
  }
  return {
    pageProps: {
      pageName,
      isBotDevice,
      brandName,
      isPdpSsr: isServerReq,
    },
  };
};

ProductDetailContainer.propTypes = {
  productDetails: arrayOf(shape({})),
  getDetails: func.isRequired,
  addToBagError: string,
  clearAddToBagError: func.isRequired,
  formValues: shape({}).isRequired,
  addToBagEcom: func.isRequired,
  productInfo: arrayOf(shape({})),
  breadCrumbs: shape([]),
  longDescription: string,
  shortDescription: string,
  itemPartNumber: string,
  ratingsProductId: string,
  isShowPriceRangeKillSwitch: bool.isRequired,
  showPriceRangeForABTest: bool.isRequired,
  router: shape({
    query: shape({
      pid: string,
      isSearchPage: bool,
    }),
  }).isRequired,
  defaultImage: string,
  currency: string,
  currencyAttributes: shape({}),
  onAddItemToFavorites: func.isRequired,
  isLoggedIn: bool,
  isPlcc: bool,
  alternateSizes: shape({ key: string }),
  AddToFavoriteErrorMsg: string,
  removeAddToFavoritesErrorMsg: func,
  sizeChartDetails: shape([]),
  topPromos: string,
  middlePromos: string,
  dynamicContentPromo: string,
  bottomPromos: string,
  belowrecsPromos: string,
  isLoading: bool,
  trackClickWithoutDelay: func,
  trackPageLoad: func,
  pageProps: shape({}),
  resetProductDetailsDynamicData: func.isRequired,
  isKeepAliveEnabled: bool,
  completeLookSlotTile: shape({}),
  resetProductDetails: func.isRequired,
  isInternationalShipping: bool.isRequired,
  onFavtLoad: func.isRequired,
  defaultWishListFromState: func.isRequired,
  pageUrl: string.isRequired,
  storeId: string,
  countUpdated: bool,
  resetCountUpdate: func.isRequired,
  onQuickViewOpenClick: func,
  getSocialProofData: func,
  isCompleteTheLookTestEnabled: bool,
  showAddtoBagDrawer: bool.isRequired,
  hidePriceDisplay: bool,
  addBtnMsg: string.isRequired,
  multipackProduct: string.isRequired,
  multiPackCount: string.isRequired,
  multiPackThreshold: string.isRequired,
  getAllMultiPack: shape({}).isRequired,
  partIdInfo: string.isRequired,
  getAllNewMultiPack: shape({}).isRequired,
  getRecommendationProduct: bool.isRequired,
  isPlpPdpAnchoringEnabled: bool,
  isBrierleyPromoEnabled: bool,
  isOosPdpEnabled: bool,
  isPdpNewRecommendationEnabled: bool,
  isPdp1andPdp2Enabled: bool,
  selectedMultipack: string,
  largeImageNameOnHover: string,
  hasABTestForPDPColorOrImageSwatchHover: bool,
  initialMultipackMapping: shape([]).isRequired,
  initialColorConsolidationMultipackMapping: shape([]),
  setInitialTCPStyleQty: bool.isRequired,
  onSetLastDeletedItemIdAction: func,
  deleteFavItemInProgressFlag: bool,
  disableMultiPackTab: bool.isRequired,
  getDisableSelectedTab: func.isRequired,
  istMultiColorNameEnabled: bool.isRequired,
  isDynamicBadgeEnabled: shape({}),
  isDynamicBadgeEnabledAbtest: shape({}),
  apiConfig: shape({}),
  getHomePageLayout: func.isRequired,
  layouts: shape({}),
  isPDPSmoothScrollEnabled: bool,
  isHiddenPDPAltImageEnabled: bool,
  socialProofMessage: string,
  isFamilyOutfitEnabled: bool,
  errorMessages: shape({}),
  isABTestLoaded: bool,
  isShowBrandNameEnabled: bool,
  toggleModal: func,
  isFamilyOutfitRightViewEnabled: bool,
  accessories: shape([]),
  isVerticalCTLEnabled: bool,
  appliedFiltersPLP: shape({}),
  appliedFiltersSLP: shape({}),
  isVerticalRecommendationsEnabled: bool,
  isTopRatedBadgeEnabled: bool,
  currentCategoryIdPLP: string,
  isMiniBagEnabled: bool,
  setProductDataForReviewActn: func,
  isWriteReviewModalOpen: bool,
  isAddPhotoModalOpen: bool,
  isAddVideoModalOpen: bool,
  isSubmissionFeedbackModalOpen: bool,
  isHeaderPromoEnabled: arrayOf(shape({})),
  isNewPJPPDPRedesignEnabled: bool,
  isTakeDownProduct: bool,
  takeDownCategory: string,
  isTakeDownRedirectionEnabled: bool,
  isAddBgdToTransparentImgEnabled: bool,
  isColorConsolidationEnabled: bool,
  isSyteEnabled: bool,
  syteRecommendations: shape({}),
  isSyteScriptLoaded: bool,
  isSimilarItemToConsiderEnabled: bool,
  isTopRatedBadgeEnabledSLP: bool,
  isBestSellerBadgeEnabledSLP: bool,
  isBMModalOpen: bool,
  isESGBadgePDPBackABEnabled: bool,
  toastModalState: shape({
    showToast: bool,
  }),
  showToastModalAction: func,
  outfitV3WidgetEnabled: bool,
  outfitV3WidgetVDABTestEnabled: bool,
  outfitV3WidgetMnMABTest: bool,
  isStyliticsComposerWidgetEnabled: bool,
  User: shape({}),
  APIConfig: shape({}),
  session: shape({}),
  IsImageIndicatorUpdateEnabled: bool,
  isPixleeWidget: bool,
  showDynamicContentLoader: bool,
  dynamicPromoPerfSwitch: bool,
  isPDPRedesignEnabled: bool,
  fetchAdditionalPromoModule: func,
  additionalPromoModuleXContent: shape({}),
  additionalPromoModuleXContentId: string,
  isUpdatedPromotionsDisplayEnabled: bool,
  isRcommAboveProdDesc: bool,
  isGlobalDefaultHeaderRedesignEnabled: bool,
  isTransparentImageSizeReduceEnabledForPdp: bool,
  isDyEnabled: bool,
};

ProductDetailContainer.defaultProps = {
  productDetails: [],
  productInfo: {},
  pageProps: {},
  addToBagError: '',
  breadCrumbs: null,
  longDescription: '',
  shortDescription: '',
  ratingsProductId: '',
  defaultImage: '',
  currency: 'USD',
  currencyAttributes: { exchangevalue: 1 },
  itemPartNumber: '',
  isLoggedIn: false,
  isPlcc: false,
  alternateSizes: {},
  AddToFavoriteErrorMsg: '',
  removeAddToFavoritesErrorMsg: () => {},
  sizeChartDetails: [],
  topPromos: '',
  middlePromos: '',
  dynamicContentPromo: '',
  bottomPromos: '',
  isLoading: false,
  trackClickWithoutDelay: () => {},
  trackPageLoad: () => {},
  onQuickViewOpenClick: () => {},
  getSocialProofData: () => {},
  isKeepAliveEnabled: false,
  completeLookSlotTile: {},
  storeId: null,
  countUpdated: false,
  isCompleteTheLookTestEnabled: false,
  hidePriceDisplay: false,
  isPlpPdpAnchoringEnabled: false,
  isBrierleyPromoEnabled: false,
  isOosPdpEnabled: false,
  isPdpNewRecommendationEnabled: false,
  isPdp1andPdp2Enabled: true,
  selectedMultipack: '1',
  largeImageNameOnHover: '',
  hasABTestForPDPColorOrImageSwatchHover: false,
  onSetLastDeletedItemIdAction: () => {},
  deleteFavItemInProgressFlag: false,
  isDynamicBadgeEnabled: false,
  isDynamicBadgeEnabledAbtest: false,
  apiConfig: {},
  layouts: {},
  isPDPSmoothScrollEnabled: false,
  socialProofMessage: '',
  isFamilyOutfitEnabled: false,
  errorMessages: {},
  isABTestLoaded: false,
  isShowBrandNameEnabled: false,
  toggleModal: () => {},
  accessories: [],
  isFamilyOutfitRightViewEnabled: false,
  isHiddenPDPAltImageEnabled: false,
  isVerticalCTLEnabled: false,
  appliedFiltersPLP: {},
  appliedFiltersSLP: {},
  isVerticalRecommendationsEnabled: false,
  isTopRatedBadgeEnabled: false,
  currentCategoryIdPLP: '',
  isMiniBagEnabled: false,
  setProductDataForReviewActn: () => {},
  isWriteReviewModalOpen: false,
  isAddPhotoModalOpen: false,
  isAddVideoModalOpen: false,
  isSubmissionFeedbackModalOpen: false,
  isHeaderPromoEnabled: [],
  isNewPJPPDPRedesignEnabled: false,
  isTakeDownProduct: false,
  takeDownCategory: '',
  isTakeDownRedirectionEnabled: false,
  isAddBgdToTransparentImgEnabled: false,
  isColorConsolidationEnabled: false,
  initialColorConsolidationMultipackMapping: [],
  isSyteEnabled: false,
  isSyteScriptLoaded: false,
  isSimilarItemToConsiderEnabled: false,
  isTopRatedBadgeEnabledSLP: false,
  isBestSellerBadgeEnabledSLP: false,
  isBMModalOpen: false,
  isESGBadgePDPBackABEnabled: false,
  toastModalState: {
    duration: 0,
    showToast: false,
  },
  showToastModalAction: () => {},
  outfitV3WidgetEnabled: false,
  outfitV3WidgetVDABTestEnabled: false,
  outfitV3WidgetMnMABTest: false,
  isStyliticsComposerWidgetEnabled: false,
  User: {},
  APIConfig: {},
  session: {},
  IsImageIndicatorUpdateEnabled: false,
  isPixleeWidget: false,
  showDynamicContentLoader: false,
  dynamicPromoPerfSwitch: false,
  isPDPRedesignEnabled: false,
  fetchAdditionalPromoModule: () => {},
  additionalPromoModuleXContentId: '',
  additionalPromoModuleXContent: null,
  isUpdatedPromotionsDisplayEnabled: false,
  isRcommAboveProdDesc: false,
  isGlobalDefaultHeaderRedesignEnabled: false,
  isTransparentImageSizeReduceEnabledForPdp: false,
  isDyEnabled: false,
};

const PDPConnectComponent = connect(mapStateToProps, mapDispatchToProps)(ProductDetailContainer);

const PDPRouterWrapper = withRouter(PDPConnectComponent);

hoistNonReactStatic(PDPRouterWrapper, PDPConnectComponent, {
  getInitialProps: true,
});

const withReducer = withDynamicReducer([{ key: 'AddedToBagReducer', reducer: AddedToBagReducer }]);
const withSaga = withDynamicSaga([{ key: 'AddedToBagSaga', saga: AddedToBagSaga }]);
const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withReducer, withSaga, withConnect)(PDPRouterWrapper);
